export const translations = {
  en: {
    // Landing Page
    landing_title: "Understand Your Emotional Landscape",
    landing_subtitle: "A professional tool for tracking emotional patterns, gaining insights, and cultivating emotional intelligence.",
    multi_dimensional: "Multi-Dimensional Tracking",
    multi_dimensional_desc: "Map emotions across valence, arousal, and context",
    pattern_recognition: "Pattern Recognition",
    pattern_recognition_desc: "Discover trends in your emotional wellness journey",
    community_insights: "Community Insights",
    community_insights_desc: "Connect with shared experiences, anonymously",
    ai_companion: "AI Companion",
    ai_companion_desc: "Evidence-based support and reflection",
    welcome_back: "Welcome Back",
    begin_journey: "Begin Your Journey",
    name: "Name",
    email: "Email",
    password: "Password",
    log_in: "Log In",
    create_account: "Create Account",
    no_account: "Don't have an account? Create one",
    have_account: "Already have an account? Log in",
    
    // Onboarding
    tell_us_about: "Tell us about yourself",
    language_preference: "Preferred Language",
    music_preferences: "Music Preferences",
    music_pref_desc: "Select genres you enjoy (helps personalize recommendations)",
    food_preferences: "Dietary Preferences",
    food_pref_desc: "Any dietary restrictions or preferences",
    wellness_goals: "Wellness Goals",
    wellness_goals_desc: "What brings you to MyMojo?",
    continue: "Continue",
    skip: "Skip for now",
    
    // Voice Chat
    voice_chat: "Voice Chat",
    start_talking: "Start Talking",
    listening: "Listening... Tap to stop",
    processing: "Processing your message...",
    tap_to_speak: "Tap the microphone to start talking",
    
    // Navigation
    dashboard: "Dashboard",
    history: "History",
    journal: "Journal",
    music: "Music",
    community: "Community",
    chat: "Chat",
    voice: "Voice",
    settings: "Settings",
    logout: "Logout",
    back: "Back",
    home: "Home",
    welcome: "Welcome",
    
    // Settings
    select_language_desc: "Choose your preferred language for the app",
    language_updated: "Language updated successfully!",
    profile_information: "Profile Information",
    location: "Location",
    saving: "Saving",
    gender: "Gender",
    male: "Male",
    female: "Female",
    
    // Dashboard
    good_to_see: "Good to see you",
    lets_explore: "Let's explore what you're feeling right now",
    check_in_prompt: "Take a moment to check in with yourself",
    step_of: "Step {step} of {total}",
    whats_primary_feeling: "What's your primary feeling right now?",
    browse_emotions: "Browse through emotions using the carousel",
    which_specific_feeling: "Which specific feeling resonates most?",
    select_one_below: "Select one below",
    what_physical_sensations: "What physical sensations accompany this feeling?",
    when_you_feel: "When you feel",
    what_notice_body: "what do you notice in your body?",
    for_example_sensations: "For example: tingling hands, warm chest, energetic legs, tense shoulders, butterflies in stomach",
    continue_to_context: "Continue to Context",
    no_physical_sensations: "I don't feel any physical sensations right now → Skip",
    add_context_intensity: "Add context & intensity",
    your_emotional_state: "Your Emotional State",
    category: "Category",
    body: "Body",
    how_intense: "How intense is this feeling?",
    whats_reason: "What's the reason or context?",
    why_feeling_this: "Why are you feeling this way? What happened?",
    add_tags: "Add tags (optional, comma-separated)",
    example_tags: "e.g., work, family, health",
    save_track_emotion: "Save & Track Emotion",
    track_another: "Track Another Emotion",
    quote_of_moment: "Quote of the Moment",
    your_insights: "Your Insights",
    achievements: "Achievements",
    unlocked: "Unlocked",
    mild: "Mild",
    strong: "Strong",
    based_on_feeling: "Based on your feeling:",
    click_action_below: "👇 Click any action below to get started",
    try_these_actions: "Try These Actions:",
    click_to_try: "Click to try",
    open: "Open",
    select_this_category: "Select This Category",
    specific_feelings: "{count} specific feelings",
    positive: "Positive",
    challenging: "Challenging",
    neutral: "Neutral",
    
    // Emotion Categories
    emotion_accepting_open: "Accepting/Open",
    emotion_aliveness_joy: "Aliveness/Joy",
    emotion_angry_annoyed: "Angry/Annoyed",
    emotion_connected_loving: "Connected/Loving",
    emotion_curious: "Curious",
    emotion_despair_sad: "Despair/Sad",
    emotion_disconnected_numb: "Disconnected/Numb",
    emotion_embarrassed_shame: "Embarrassed/Shame",
    emotion_fear: "Fear",
    emotion_fragile: "Fragile",
    emotion_grateful: "Grateful",
    emotion_guilt: "Guilt",
    emotion_hopeful: "Hopeful",
    emotion_powerless: "Powerless",
    emotion_courageous_powerful: "Courageous/Powerful",
    emotion_stressed_tense: "Stressed/Tense",
    emotion_tender: "Tender",
    emotion_unsettled_doubt: "Unsettled/Doubt",
    
    // Common Feelings (most used across categories)
    feeling_calm: "Calm",
    feeling_happy: "Happy",
    feeling_excited: "Excited",
    feeling_anxious: "Anxious",
    feeling_sad: "Sad",
    feeling_angry: "Angry",
    feeling_peaceful: "Peaceful",
    feeling_grateful: "Grateful",
    feeling_worried: "Worried",
    feeling_confident: "Confident",
    feeling_frustrated: "Frustrated",
    feeling_content: "Content",
    feeling_scared: "Scared",
    feeling_hopeful: "Hopeful",
    feeling_lonely: "Lonely",
    feeling_energized: "Energized",
    feeling_tired: "Tired",
    feeling_relaxed: "Relaxed",
    feeling_helpless: "Helpless",
    feeling_sensitive: "Sensitive",
    feeling_centered: "Centered",
    feeling_fulfilled: "Fulfilled",
    feeling_patient: "Patient",
    feeling_present: "Present",
    feeling_serene: "Serene",
    feeling_trusting: "Trusting",
    feeling_amazed: "Amazed",
    feeling_awe: "Awe",
    feeling_bliss: "Bliss",
    feeling_delighted: "Delighted",
    feeling_eager: "Eager",
    feeling_ecstatic: "Ecstatic",
    feeling_enchanted: "Enchanted",
    feeling_engaged: "Engaged",
    feeling_enthusiastic: "Enthusiastic",
    feeling_free: "Free",
    feeling_inspired: "Inspired",
    feeling_invigorated: "Invigorated",
    feeling_lively: "Lively",
    feeling_passionate: "Passionate",
    feeling_playful: "Playful",
    feeling_radiant: "Radiant",
    feeling_refreshed: "Refreshed",
    feeling_rejuvenated: "Rejuvenated",
    feeling_renewed: "Renewed",
    feeling_satisfied: "Satisfied",
    feeling_thrilled: "Thrilled",
    feeling_vibrant: "Vibrant",
    feeling_agitated: "Agitated",
    feeling_aggravated: "Aggravated",
    feeling_bitter: "Bitter",
    feeling_contempt: "Contempt",
    feeling_cynical: "Cynical",
    feeling_disdain: "Disdain",
    feeling_disgruntled: "Disgruntled",
    feeling_disturbed: "Disturbed",
    feeling_edgy: "Edgy",
    feeling_exasperated: "Exasperated",
    feeling_furious: "Furious",
    feeling_grouchy: "Grouchy",
    feeling_hostile: "Hostile",
    feeling_impatient: "Impatient",
    feeling_irritated: "Irritated",
    feeling_irate: "Irate",
    feeling_moody: "Moody",
    feeling_on_edge: "On edge",
    feeling_outraged: "Outraged",
    feeling_pissed: "Pissed",
    feeling_resentful: "Resentful",
    feeling_upset: "Upset",
    feeling_vindictive: "Vindictive",
    feeling_accepting: "Accepting",
    feeling_affectionate: "Affectionate",
    feeling_caring: "Caring",
    feeling_compassion: "Compassion",
    feeling_empathy: "Empathy",
    feeling_safe: "Safe",
    feeling_warm: "Warm",
    feeling_worthy: "Worthy",
    feeling_exploring: "Exploring",
    feeling_fascinated: "Fascinated",
    feeling_interested: "Interested",
    feeling_intrigued: "Intrigued",
    feeling_involved: "Involved",
    feeling_stimulated: "Stimulated",
    feeling_anguish: "Anguish",
    feeling_depressed: "Depressed",
    feeling_despondent: "Despondent",
    feeling_disappointed: "Disappointed",
    feeling_discouraged: "Discouraged",
    feeling_forlorn: "Forlorn",
    feeling_gloomy: "Gloomy",
    feeling_grief: "Grief",
    feeling_heartbroken: "Heartbroken",
    feeling_hopeless: "Hopeless",
    feeling_longing: "Longing",
    feeling_melancholy: "Melancholy",
    feeling_sorrow: "Sorrow",
    feeling_teary: "Teary",
    feeling_unhappy: "Unhappy",
    feeling_weary: "Weary",
    feeling_yearning: "Yearning",
    feeling_aloof: "Aloof",
    feeling_bored: "Bored",
    feeling_confused: "Confused",
    feeling_distant: "Distant",
    feeling_empty: "Empty",
    feeling_indifferent: "Indifferent",
    feeling_isolated: "Isolated",
    feeling_lethargic: "Lethargic",
    feeling_listless: "Listless",
    feeling_removed: "Removed",
    feeling_resistant: "Resistant",
    feeling_shut_down: "Shut Down",
    feeling_uneasy: "Uneasy",
    feeling_withdrawn: "Withdrawn",
    feeling_ashamed: "Ashamed",
    feeling_humiliated: "Humiliated",
    feeling_inhibited: "Inhibited",
    feeling_mortified: "Mortified",
    feeling_self_conscious: "Self-conscious",
    feeling_useless: "Useless",
    feeling_weak: "Weak",
    feeling_worthless: "Worthless",
    feeling_afraid: "Afraid",
    feeling_apprehensive: "Apprehensive",
    feeling_frightened: "Frightened",
    feeling_hesitant: "Hesitant",
    feeling_nervous: "Nervous",
    feeling_panic: "Panic",
    feeling_paralyzed: "Paralyzed",
    feeling_terrified: "Terrified",
    feeling_appreciative: "Appreciative",
    feeling_blessed: "Blessed",
    feeling_fortunate: "Fortunate",
    feeling_grace: "Grace",
    feeling_humbled: "Humbled",
    feeling_lucky: "Lucky",
    feeling_moved: "Moved",
    feeling_thankful: "Thankful",
    feeling_touched: "Touched",
    feeling_regret: "Regret",
    feeling_remorseful: "Remorseful",
    feeling_sorry: "Sorry",
    feeling_encouraged: "Encouraged",
    feeling_expectant: "Expectant",
    feeling_optimistic: "Optimistic",
    feeling_impotent: "Impotent",
    feeling_incapable: "Incapable",
    feeling_resigned: "Resigned",
    feeling_trapped: "Trapped",
    feeling_victim: "Victim",
    feeling_adventurous: "Adventurous",
    feeling_brave: "Brave",
    feeling_capable: "Capable",
    feeling_daring: "Daring",
    feeling_determined: "Determined",
    feeling_grounded: "Grounded",
    feeling_proud: "Proud",
    feeling_strong: "Strong",
    feeling_valiant: "Valiant",
    feeling_burned_out: "Burned out",
    feeling_cranky: "Cranky",
    feeling_depleted: "Depleted",
    feeling_exhausted: "Exhausted",
    feeling_frazzled: "Frazzled",
    feeling_overwhelm: "Overwhelm",
    feeling_rattled: "Rattled",
    feeling_rejecting: "Rejecting",
    feeling_restless: "Restless",
    feeling_shaken: "Shaken",
    feeling_tight: "Tight",
    feeling_worn_out: "Worn out",
    feeling_loving: "Loving",
    feeling_reflective: "Reflective",
    feeling_self_loving: "Self-loving",
    feeling_vulnerable: "Vulnerable",
    feeling_concerned: "Concerned",
    feeling_dissatisfied: "Dissatisfied",
    feeling_perplexed: "Perplexed",
    feeling_questioning: "Questioning",
    feeling_reluctant: "Reluctant",
    feeling_shocked: "Shocked",
    feeling_skeptical: "Skeptical",
    feeling_suspicious: "Suspicious",
    feeling_ungrounded: "Ungrounded",
    feeling_unsure: "Unsure",
    
    // Quotes
    quote_accepting_open: "If your compassion does not include yourself, it is incomplete. — Jack Kornfield",
    quote_aliveness_joy: "Joy is what happens when we allow ourselves to recognize how good things really are. — Marianne Williamson",
    quote_angry_annoyed: "Anger is an acid that can do more harm to the vessel in which it is stored than to anything on which it is poured. — Mark Twain",
    quote_connected_loving: "Where there is love, there is life. — Mahatma Gandhi",
    quote_curious: "Know thyself, for once we know ourselves, we may learn how to care for ourselves. — Socrates",
    quote_despair_sad: "This too shall pass. Every emotion is temporary, and healing is a journey.",
    quote_disconnected_numb: "Until you value yourself, you won't value your time. — Swami Vivekananda",
    quote_embarrassed_shame: "Healing comes from taking responsibility and showing yourself compassion.",
    quote_fear: "You are not your thoughts. Observe your fear without judgment, and it will lose its power.",
    quote_fragile: "Your sensitivity is your strength. Honor where you are right now.",
    quote_grateful: "Gratitude turns what we have into enough. — Melody Beattie",
    quote_guilt: "Mistakes are proof that you're trying. Learn, forgive yourself, and move forward.",
    quote_hopeful: "Hope is powerful. It can move us forward even in the darkest of times.",
    quote_powerless: "Power comes not from changing external circumstances, but from recognizing the strength within.",
    quote_courageous_powerful: "Courage is not the absence of fear, but rather the judgment that something else is more important. — Ambedkar",
    quote_stressed_tense: "Breath is like a remote control for your nervous system. — Dr. Andrew Weil",
    quote_tender: "There is immense power in tenderness. Let your sensitivity be your greatest strength.",
    quote_unsettled_doubt: "In the midst of doubt, pause and return to your breath. Clarity will come with time.",
    emotion_spectrum: "Emotion Spectrum",
    selected_emotion: "Selected Emotion",
    valence_label: "Valence (Pleasant ↔ Unpleasant)",
    arousal_label: "Arousal (Calm ↔ Energized)",
    context_reflection: "Context & Reflection",
    context_placeholder: "What's contributing to this emotional state?",
    tags: "Tags",
    tags_placeholder: "work, relationships, health, exercise",
    record_state: "Record Emotional State",
    your_insights: "Your Insights",
    total_checkins: "Total Check-ins",
    avg_intensity: "Average Intensity",
    recent_states: "Recent States",
    
    // Music & Food
    music_food: "Music & Wellness",
    personalized_recommendations: "Personalized recommendations based on your mood",
    how_feeling: "How are you feeling?",
    music_for_mood: "Music for Your Mood",
    nearby_wellness: "Nearby Wellness",
    open_spotify: "Open in Spotify",
    open_youtube: "Open in YouTube",
    open_apple: "Open in Apple Music",
    order_talabat: "Order on Talabat",
    order_noon: "Order on Noon",
    
    // Emotions
    joy: "Joy",
    joy_desc: "Contentment and happiness",
    excitement: "Excitement",
    excitement_desc: "High energy positivity",
    serenity: "Serenity",
    serenity_desc: "Peaceful calm",
    contentment: "Contentment",
    contentment_desc: "Satisfied ease",
    interest: "Interest",
    interest_desc: "Engaged curiosity",
    neutral: "Neutral",
    neutral_desc: "Balanced state",
    sadness: "Sadness",
    sadness_desc: "Low mood",
    anxiety: "Anxiety",
    anxiety_desc: "Worried tension",
    anger: "Anger",
    anger_desc: "Frustrated irritation",
    fatigue: "Fatigue",
    fatigue_desc: "Exhausted weariness",
    melancholy: "Melancholy",
    melancholy_desc: "Deep sadness",
    overwhelm: "Overwhelm",
    overwhelm_desc: "Cannot cope"
  },
  
  es: {
    // Spanish translations - Complete
    landing_title: "Comprende Tu Paisaje Emocional",
    landing_subtitle: "Una herramienta profesional para rastrear patrones emocionales, obtener insights y cultivar inteligencia emocional.",
    welcome_back: "Bienvenido de Nuevo",
    begin_journey: "Comienza Tu Viaje",
    name: "Nombre",
    first_name: "Nombre",
    surname: "Apellido",
    email: "Correo Electrónico",
    password: "Contraseña",
    log_in: "Iniciar Sesión",
    create_account: "Crear Cuenta",
    
    // Navigation
    dashboard: "Panel",
    history: "Historial",
    journal: "Diario",
    music: "Música",
    community: "Comunidad",
    chat: "Chat",
    voice: "Voz",
    settings: "Configuración",
    logout: "Cerrar Sesión",
    back: "Volver",
    home: "Inicio",
    welcome: "Bienvenido",
    
    // Dashboard
    good_to_see: "Qué bueno verte",
    lets_explore: "Exploremos lo que estás sintiendo ahora",
    step_of: "Paso {step} de {total}",
    whats_primary_feeling: "¿Cuál es tu sentimiento principal ahora?",
    browse_emotions: "Explora emociones usando el carrusel",
    which_specific_feeling: "¿Qué sentimiento específico resuena más?",
    what_physical_sensations: "¿Qué sensaciones físicas acompañan este sentimiento?",
    when_you_feel: "Cuando sientes",
    what_notice_body: "¿qué notas en tu cuerpo?",
    for_example_sensations: "Por ejemplo: manos hormigueantes, pecho cálido, piernas energizadas, hombros tensos",
    continue_to_context: "Continuar al Contexto",
    no_physical_sensations: "No siento sensaciones físicas ahora → Saltar",
    add_context_intensity: "Agregar contexto e intensidad",
    your_emotional_state: "Tu Estado Emocional",
    category: "Categoría",
    body: "Cuerpo",
    how_intense: "¿Qué tan intenso es este sentimiento?",
    whats_reason: "¿Cuál es la razón o contexto?",
    why_feeling_this: "¿Por qué te sientes así? ¿Qué pasó?",
    add_tags: "Agregar etiquetas (opcional, separadas por comas)",
    example_tags: "ej: trabajo, familia, salud",
    save_track_emotion: "Guardar y Rastrear Emoción",
    track_another: "Rastrear Otra Emoción",
    mild: "Leve",
    strong: "Fuerte",
    based_on_feeling: "Basado en tu sentimiento:",
    click_action_below: "👇 Haz clic en cualquier acción para comenzar",
    try_these_actions: "Prueba Estas Acciones:",
    click_to_try: "Clic para probar",
    open: "Abrir",
    select_this_category: "Seleccionar Esta Categoría",
    specific_feelings: "{count} sentimientos específicos",
    positive: "Positivo",
    challenging: "Desafiante",
    neutral: "Neutral",
    quote_of_moment: "Cita del Momento",
    your_insights: "Tus Perspectivas",
    
    // Settings
    select_language_desc: "Elige tu idioma preferido",
    language_updated: "¡Idioma actualizado!",
    profile_information: "Información del Perfil",
    location: "Ubicación",
    saving: "Guardando",
    gender: "Género",
    male: "Masculino",
    female: "Femenino",
    language_preference: "Idioma Preferido",
    
    // Emotion Categories


    emotion_accepting_open: "Aceptando/Abierto",
    emotion_aliveness_joy: "Vitalidad/Alegría",
    emotion_angry_annoyed: "Enojado/Molesto",
    emotion_connected_loving: "Conectado/Amoroso",
    emotion_curious: "Curioso",
    emotion_despair_sad: "Desesperación/Triste",
    emotion_disconnected_numb: "Desconectado/Entumecido",
    emotion_embarrassed_shame: "Avergonzado/Vergüenza",
    emotion_fear: "Miedo",
    emotion_fragile: "Frágil",
    emotion_grateful: "Agradecido",
    emotion_guilt: "Culpa",
    emotion_hopeful: "Esperanzado",
    emotion_powerless: "Impotente",
    emotion_courageous_powerful: "Valiente/Poderoso",
    emotion_stressed_tense: "Estresado/Tenso",
    emotion_tender: "Tierno",
    emotion_unsettled_doubt: "Inquieto/Duda",
    
    // All Feelings (170+)
    feeling_calm: "Tranquilo",
    feeling_happy: "Feliz",
    feeling_excited: "Emocionado",
    feeling_anxious: "Ansioso",
    feeling_sad: "Triste",
    feeling_angry: "Enojado",
    feeling_peaceful: "Pacífico",
    feeling_grateful: "Agradecido",
    feeling_worried: "Preocupado",
    feeling_confident: "Seguro",
    feeling_frustrated: "Frustrado",
    feeling_content: "Contento",
    feeling_scared: "Asustado",
    feeling_hopeful: "Esperanzado",
    feeling_lonely: "Solo",
    feeling_energized: "Energizado",
    feeling_tired: "Cansado",
    feeling_relaxed: "Relajado",
    feeling_helpless: "Desamparado",
    feeling_sensitive: "Sensible",
    feeling_centered: "Centrado",
    feeling_fulfilled: "Realizado",
    feeling_patient: "Paciente",
    feeling_present: "Presente",
    feeling_serene: "Sereno",
    feeling_trusting: "Confiado",
    feeling_amazed: "Asombrado",
    feeling_awe: "Asombro",
    feeling_bliss: "Dicha",
    feeling_delighted: "Encantado",
    feeling_eager: "Ansioso",
    feeling_ecstatic: "Extático",
    feeling_enchanted: "Encantado",
    feeling_engaged: "Comprometido",
    feeling_enthusiastic: "Entusiasta",
    feeling_free: "Libre",
    feeling_inspired: "Inspirado",
    feeling_invigorated: "Vigorizado",
    feeling_lively: "Vivaz",
    feeling_passionate: "Apasionado",
    feeling_playful: "Juguetón",
    feeling_radiant: "Radiante",
    feeling_refreshed: "Refrescado",
    feeling_rejuvenated: "Rejuvenecido",
    feeling_renewed: "Renovado",
    feeling_satisfied: "Satisfecho",
    feeling_thrilled: "Emocionado",
    feeling_vibrant: "Vibrante",
    feeling_agitated: "Agitado",
    feeling_aggravated: "Agravado",
    feeling_bitter: "Amargado",
    feeling_contempt: "Desprecio",
    feeling_cynical: "Cínico",
    feeling_disdain: "Desdén",
    feeling_disgruntled: "Descontento",
    feeling_disturbed: "Perturbado",
    feeling_edgy: "Nervioso",
    feeling_exasperated: "Exasperado",
    feeling_furious: "Furioso",
    feeling_grouchy: "Gruñón",
    feeling_hostile: "Hostil",
    feeling_impatient: "Impaciente",
    feeling_irritated: "Irritado",
    feeling_irate: "Iracundo",
    feeling_moody: "Malhumorado",
    feeling_on_edge: "Al límite",
    feeling_outraged: "Indignado",
    feeling_pissed: "Enojado",
    feeling_resentful: "Resentido",
    feeling_upset: "Molesto",
    feeling_vindictive: "Vengativo",
    feeling_accepting: "Aceptando",
    feeling_affectionate: "Afectuoso",
    feeling_caring: "Cariñoso",
    feeling_compassion: "Compasión",
    feeling_empathy: "Empatía",
    feeling_safe: "Seguro",
    feeling_warm: "Cálido",
    feeling_worthy: "Digno",
    feeling_exploring: "Explorando",
    feeling_fascinated: "Fascinado",
    feeling_interested: "Interesado",
    feeling_intrigued: "Intrigado",
    feeling_involved: "Involucrado",
    feeling_stimulated: "Estimulado",
    feeling_anguish: "Angustia",
    feeling_depressed: "Deprimido",
    feeling_despondent: "Desalentado",
    feeling_disappointed: "Decepcionado",
    feeling_discouraged: "Desanimado",
    feeling_forlorn: "Desolado",
    feeling_gloomy: "Sombrío",
    feeling_grief: "Duelo",
    feeling_heartbroken: "Con el corazón roto",
    feeling_hopeless: "Sin esperanza",
    feeling_longing: "Añoranza",
    feeling_melancholy: "Melancolía",
    feeling_sorrow: "Pena",
    feeling_teary: "Lloroso",
    feeling_unhappy: "Infeliz",
    feeling_weary: "Cansado",
    feeling_yearning: "Anhelo",
    feeling_aloof: "Distante",
    feeling_bored: "Aburrido",
    feeling_confused: "Confundido",
    feeling_distant: "Distante",
    feeling_empty: "Vacío",
    feeling_indifferent: "Indiferente",
    feeling_isolated: "Aislado",
    feeling_lethargic: "Letárgico",
    feeling_listless: "Apático",
    feeling_removed: "Apartado",
    feeling_resistant: "Resistente",
    feeling_shut_down: "Cerrado",
    feeling_uneasy: "Inquieto",
    feeling_withdrawn: "Retraído",
    feeling_ashamed: "Avergonzado",
    feeling_humiliated: "Humillado",
    feeling_inhibited: "Inhibido",
    feeling_mortified: "Mortificado",
    feeling_self_conscious: "Cohibido",
    feeling_useless: "Inútil",
    feeling_weak: "Débil",
    feeling_worthless: "Sin valor",
    feeling_afraid: "Asustado",
    feeling_apprehensive: "Aprensivo",
    feeling_frightened: "Atemorizado",
    feeling_hesitant: "Vacilante",
    feeling_nervous: "Nervioso",
    feeling_panic: "Pánico",
    feeling_paralyzed: "Paralizado",
    feeling_terrified: "Aterrorizado",
    feeling_appreciative: "Apreciativo",
    feeling_blessed: "Bendecido",
    feeling_fortunate: "Afortunado",
    feeling_grace: "Gracia",
    feeling_humbled: "Humilde",
    feeling_lucky: "Afortunado",
    feeling_moved: "Conmovido",
    feeling_thankful: "Agradecido",
    feeling_touched: "Tocado",
    feeling_regret: "Arrepentimiento",
    feeling_remorseful: "Arrepentido",
    feeling_sorry: "Arrepentido",
    feeling_encouraged: "Alentado",
    feeling_expectant: "Expectante",
    feeling_optimistic: "Optimista",
    feeling_impotent: "Impotente",
    feeling_incapable: "Incapaz",
    feeling_resigned: "Resignado",
    feeling_trapped: "Atrapado",
    feeling_victim: "Víctima",
    feeling_adventurous: "Aventurero",
    feeling_brave: "Valiente",
    feeling_capable: "Capaz",
    feeling_daring: "Atrevido",
    feeling_determined: "Determinado",
    feeling_grounded: "Conectado a tierra",
    feeling_proud: "Orgulloso",
    feeling_strong: "Fuerte",
    feeling_valiant: "Valiente",
    feeling_burned_out: "Quemado",
    feeling_cranky: "Irritable",
    feeling_depleted: "Agotado",
    feeling_exhausted: "Exhausto",
    feeling_frazzled: "Agotado",
    feeling_overwhelm: "Abrumado",
    feeling_rattled: "Perturbado",
    feeling_rejecting: "Rechazando",
    feeling_restless: "Inquieto",
    feeling_shaken: "Sacudido",
    feeling_tight: "Tenso",
    feeling_worn_out: "Desgastado",
    feeling_loving: "Amoroso",
    feeling_reflective: "Reflexivo",
    feeling_self_loving: "Auto-amoroso",
    feeling_vulnerable: "Vulnerable",
    feeling_concerned: "Preocupado",
    feeling_dissatisfied: "Insatisfecho",
    feeling_perplexed: "Perplejo",
    feeling_questioning: "Cuestionando",
    feeling_reluctant: "Reacio",
    feeling_shocked: "Conmocionado",
    feeling_skeptical: "Escéptico",
    feeling_suspicious: "Sospechoso",
    feeling_ungrounded: "Desarraigado",
    feeling_unsure: "Inseguro",
    
    // Quotes in Spanish
    quote_accepting_open: "Si tu compasión no te incluye a ti mismo, está incompleta. — Jack Kornfield",
    quote_aliveness_joy: "La alegría es lo que sucede cuando nos permitimos reconocer lo buenas que son las cosas. — Marianne Williamson",
    quote_angry_annoyed: "La ira es un ácido que puede hacer más daño al recipiente que la contiene. — Mark Twain",
    quote_connected_loving: "Donde hay amor, hay vida. — Mahatma Gandhi",
    quote_curious: "Conócete a ti mismo, porque una vez que nos conocemos, podemos aprender a cuidarnos. — Sócrates",
    quote_despair_sad: "Esto también pasará. Cada emoción es temporal, y la sanación es un viaje.",
    quote_disconnected_numb: "Hasta que te valores a ti mismo, no valorarás tu tiempo. — Swami Vivekananda",
    quote_embarrassed_shame: "La sanación viene de tomar responsabilidad y mostrarte compasión.",
    quote_fear: "No eres tus pensamientos. Observa tu miedo sin juicio y perderá su poder.",
    quote_fragile: "Tu sensibilidad es tu fortaleza. Honra donde estás ahora.",
    quote_grateful: "La gratitud convierte lo que tenemos en suficiente. — Melody Beattie",
    quote_guilt: "Los errores son prueba de que estás intentando. Aprende, perdónate y avanza.",
    quote_hopeful: "La esperanza es poderosa. Puede moverte incluso en los momentos más oscuros.",
    quote_powerless: "El poder no viene de cambiar las circunstancias externas, sino de reconocer la fuerza interior.",
    quote_courageous_powerful: "El coraje no es la ausencia de miedo, sino el juicio de que algo más es importante.",
    quote_stressed_tense: "La respiración es como un control remoto para tu sistema nervioso. — Dr. Andrew Weil",
    quote_tender: "Hay un inmenso poder en la ternura. Deja que tu sensibilidad sea tu mayor fortaleza.",
    quote_unsettled_doubt: "En medio de la duda, pausa y regresa a tu respiración. La claridad vendrá con el tiempo.",
    
    // Settings
    select_language_desc: "Elige tu idioma preferido para la aplicación",
    profile_information: "Información del Perfil",
    saving: "Guardando",
    language_updated: "¡Idioma actualizado correctamente!"
  },
  
  ar: {
    // Arabic translations (RTL) - Complete
    landing_title: "افهم مشهدك العاطفي",
    landing_subtitle: "أداة احترافية لتتبع الأنماط العاطفية واكتساب الرؤى وتنمية الذكاء العاطفي",
    welcome_back: "مرحباً بعودتك",
    begin_journey: "ابدأ رحلتك",
    name: "الاسم",
    first_name: "الاسم الأول",
    surname: "اسم العائلة",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    log_in: "تسجيل الدخول",
    create_account: "إنشاء حساب",
    
    // Navigation
    dashboard: "لوحة التحكم",
    history: "التاريخ",
    journal: "المذكرات",
    music: "الموسيقى",
    community: "المجتمع",
    chat: "الدردشة",
    voice: "الصوت",
    settings: "الإعدادات",
    logout: "تسجيل الخروج",
    back: "رجوع",
    home: "الرئيسية",
    welcome: "مرحباً",
    
    // Dashboard
    good_to_see: "من الجيد رؤيتك",
    lets_explore: "دعنا نستكشف ما تشعر به الآن",
    step_of: "خطوة {step} من {total}",
    whats_primary_feeling: "ما هو شعورك الأساسي الآن؟",
    browse_emotions: "تصفح المشاعر باستخدام العرض الدوار",
    which_specific_feeling: "أي شعور محدد يتردد صداه أكثر؟",
    what_physical_sensations: "ما هي الأحاسيس الجسدية المصاحبة لهذا الشعور؟",
    when_you_feel: "عندما تشعر",
    what_notice_body: "ماذا تلاحظ في جسدك؟",
    continue_to_context: "المتابعة إلى السياق",
    no_physical_sensations: "لا أشعر بأي أحاسيس جسدية → تخطي",
    add_context_intensity: "إضافة السياق والشدة",
    your_emotional_state: "حالتك العاطفية",
    category: "الفئة",
    body: "الجسد",
    how_intense: "ما مدى شدة هذا الشعور؟",
    whats_reason: "ما هو السبب أو السياق؟",
    save_track_emotion: "حفظ وتتبع العاطفة",
    track_another: "تتبع عاطفة أخرى",
    mild: "خفيف",
    strong: "قوي",
    based_on_feeling: "بناءً على شعورك:",
    try_these_actions: "جرب هذه الإجراءات:",
    click_to_try: "انقر للتجربة",
    select_this_category: "اختر هذه الفئة",
    specific_feelings: "{count} مشاعر محددة",
    positive: "إيجابي",
    challenging: "صعب",
    neutral: "محايد",
    quote_of_moment: "اقتباس اللحظة",
    your_insights: "رؤاك",
    gender: "الجنس",
    male: "ذكر",
    female: "أنثى",
    
    // Emotion Categories
    emotion_accepting_open: "قبول/منفتح",
    emotion_aliveness_joy: "حيوية/فرح",
    emotion_angry_annoyed: "غاضب/منزعج",
    emotion_connected_loving: "متصل/محب",
    emotion_curious: "فضولي",
    emotion_despair_sad: "يأس/حزين",
    emotion_disconnected_numb: "منفصل/خدر",
    emotion_embarrassed_shame: "محرج/خزي",
    emotion_fear: "خوف",
    emotion_fragile: "هش",
    emotion_grateful: "ممتن",
    emotion_guilt: "ذنب",
    emotion_hopeful: "متفائل",
    emotion_powerless: "عاجز",
    emotion_courageous_powerful: "شجاع/قوي",
    emotion_stressed_tense: "متوتر/مشدود",
    emotion_tender: "رقيق",
    emotion_unsettled_doubt: "قلق/شك",
    
    // Feelings (170+)
    feeling_calm: "هادئ",
    feeling_happy: "سعيد",
    feeling_excited: "متحمس",
    feeling_anxious: "قلق",
    feeling_sad: "حزين",
    feeling_angry: "غاضب",
    feeling_peaceful: "مسالم",
    feeling_grateful: "ممتن",
    feeling_worried: "قلق",
    feeling_confident: "واثق",
    feeling_frustrated: "محبط",
    feeling_content: "راضٍ",
    feeling_scared: "خائف",
    feeling_hopeful: "متفائل",
    feeling_lonely: "وحيد",
    feeling_energized: "نشيط",
    feeling_tired: "متعب",
    feeling_relaxed: "مسترخي",
    feeling_helpless: "عاجز",
    feeling_sensitive: "حساس",
    feeling_centered: "متمركز",
    feeling_fulfilled: "راضٍ",
    feeling_patient: "صبور",
    feeling_present: "حاضر",
    feeling_serene: "هادئ",
    feeling_trusting: "واثق",
    feeling_amazed: "مندهش",
    feeling_awe: "رهبة",
    feeling_bliss: "نعيم",
    feeling_delighted: "مسرور",
    feeling_eager: "متلهف",
    feeling_ecstatic: "منتشي",
    feeling_enchanted: "مفتون",
    feeling_engaged: "منخرط",
    feeling_enthusiastic: "متحمس",
    feeling_free: "حر",
    feeling_inspired: "ملهم",
    feeling_invigorated: "منشط",
    feeling_lively: "حيوي",
    feeling_passionate: "عاطفي",
    feeling_playful: "مرح",
    feeling_radiant: "مشرق",
    feeling_refreshed: "منتعش",
    feeling_rejuvenated: "متجدد",
    feeling_renewed: "محدث",
    feeling_satisfied: "راضٍ",
    feeling_thrilled: "مبتهج",
    feeling_vibrant: "حيوي",
    feeling_agitated: "مضطرب",
    feeling_aggravated: "متفاقم",
    feeling_bitter: "مرير",
    feeling_contempt: "احتقار",
    feeling_cynical: "ساخر",
    feeling_disdain: "ازدراء",
    feeling_disgruntled: "ساخط",
    feeling_disturbed: "مضطرب",
    feeling_edgy: "متوتر",
    feeling_exasperated: "مستاء",
    feeling_furious: "غاضب جداً",
    feeling_grouchy: "عبوس",
    feeling_hostile: "عدائي",
    feeling_impatient: "غير صبور",
    feeling_irritated: "منزعج",
    feeling_irate: "غاضب",
    feeling_moody: "متقلب المزاج",
    feeling_on_edge: "على الحافة",
    feeling_outraged: "غاضب",
    feeling_pissed: "غاضب",
    feeling_resentful: "حاقد",
    feeling_upset: "منزعج",
    feeling_vindictive: "انتقامي",
    feeling_accepting: "قابل",
    feeling_affectionate: "حنون",
    feeling_caring: "مهتم",
    feeling_compassion: "رحمة",
    feeling_empathy: "تعاطف",
    feeling_safe: "آمن",
    feeling_warm: "دافئ",
    feeling_worthy: "جدير",
    feeling_exploring: "استكشاف",
    feeling_fascinated: "مفتون",
    feeling_interested: "مهتم",
    feeling_intrigued: "مفتون",
    feeling_involved: "منخرط",
    feeling_stimulated: "محفز",
    feeling_anguish: "كرب",
    feeling_depressed: "مكتئب",
    feeling_despondent: "يائس",
    feeling_disappointed: "محبط",
    feeling_discouraged: "محبط",
    feeling_forlorn: "وحيد",
    feeling_gloomy: "كئيب",
    feeling_grief: "حزن",
    feeling_heartbroken: "مكسور القلب",
    feeling_hopeless: "يائس",
    feeling_longing: "شوق",
    feeling_melancholy: "كآبة",
    feeling_sorrow: "حزن",
    feeling_teary: "دامع",
    feeling_unhappy: "غير سعيد",
    feeling_weary: "متعب",
    feeling_yearning: "اشتياق",
    feeling_aloof: "منعزل",
    feeling_bored: "ملل",
    feeling_confused: "مشوش",
    feeling_distant: "بعيد",
    feeling_empty: "فارغ",
    feeling_indifferent: "غير مبالٍ",
    feeling_isolated: "معزول",
    feeling_lethargic: "خامل",
    feeling_listless: "خامل",
    feeling_removed: "منفصل",
    feeling_resistant: "مقاوم",
    feeling_shut_down: "مغلق",
    feeling_uneasy: "قلق",
    feeling_withdrawn: "منطوي",
    feeling_ashamed: "خجل",
    feeling_humiliated: "مهان",
    feeling_inhibited: "مثبط",
    feeling_mortified: "محرج",
    feeling_self_conscious: "واعي بالذات",
    feeling_useless: "عديم الفائدة",
    feeling_weak: "ضعيف",
    feeling_worthless: "عديم القيمة",
    feeling_afraid: "خائف",
    feeling_apprehensive: "قلق",
    feeling_frightened: "مرعوب",
    feeling_hesitant: "متردد",
    feeling_nervous: "متوتر",
    feeling_panic: "ذعر",
    feeling_paralyzed: "مشلول",
    feeling_terrified: "مرعوب",
    feeling_appreciative: "ممتن",
    feeling_blessed: "مبارك",
    feeling_fortunate: "محظوظ",
    feeling_grace: "نعمة",
    feeling_humbled: "متواضع",
    feeling_lucky: "محظوظ",
    feeling_moved: "متأثر",
    feeling_thankful: "شاكر",
    feeling_touched: "متأثر",
    feeling_regret: "ندم",
    feeling_remorseful: "نادم",
    feeling_sorry: "آسف",
    feeling_encouraged: "مشجع",
    feeling_expectant: "متوقع",
    feeling_optimistic: "متفائل",
    feeling_impotent: "عاجز",
    feeling_incapable: "غير قادر",
    feeling_resigned: "مستسلم",
    feeling_trapped: "محاصر",
    feeling_victim: "ضحية",
    feeling_adventurous: "مغامر",
    feeling_brave: "شجاع",
    feeling_capable: "قادر",
    feeling_daring: "جريء",
    feeling_determined: "مصمم",
    feeling_grounded: "ثابت",
    feeling_proud: "فخور",
    feeling_strong: "قوي",
    feeling_valiant: "شجاع",
    feeling_burned_out: "منهك",
    feeling_cranky: "عصبي",
    feeling_depleted: "مستنزف",
    feeling_exhausted: "منهك",
    feeling_frazzled: "مرهق",
    feeling_overwhelm: "مرهق",
    feeling_rattled: "مهزوز",
    feeling_rejecting: "رافض",
    feeling_restless: "قلق",
    feeling_shaken: "مهزوز",
    feeling_tight: "متوتر",
    feeling_worn_out: "منهك",
    feeling_loving: "محب",
    feeling_reflective: "تأملي",
    feeling_self_loving: "محب للذات",
    feeling_vulnerable: "ضعيف",
    feeling_concerned: "قلق",
    feeling_dissatisfied: "غير راضٍ",
    feeling_perplexed: "حائر",
    feeling_questioning: "متسائل",
    feeling_reluctant: "متردد",
    feeling_shocked: "صدم",
    feeling_skeptical: "متشكك",
    feeling_suspicious: "مشبوه",
    feeling_ungrounded: "غير مستقر",
    feeling_unsure: "غير متأكد",
    
    // Quotes in Arabic
    quote_accepting_open: "إذا لم تشمل رحمتك نفسك، فهي غير كاملة. — جاك كورنفيلد",
    quote_aliveness_joy: "الفرح هو ما يحدث عندما نسمح لأنفسنا بالتعرف على مدى جودة الأشياء. — ماريان ويليامسون",
    quote_angry_annoyed: "الغضب حمض يمكن أن يضر الوعاء الذي يحتويه أكثر. — مارك توين",
    quote_connected_loving: "حيث يوجد الحب، توجد الحياة. — المهاتما غاندي",
    quote_curious: "اعرف نفسك، لأنه بمجرد أن نعرف أنفسنا، يمكننا أن نتعلم كيف نعتني بأنفسنا. — سقراط",
    quote_despair_sad: "هذا أيضا سيمر. كل عاطفة مؤقتة، والشفاء رحلة.",
    quote_disconnected_numb: "حتى تقدر نفسك، لن تقدر وقتك. — سوامي فيفيكاناندا",
    quote_embarrassed_shame: "الشفاء يأتي من تحمل المسؤولية وإظهار الرحمة لنفسك.",
    quote_fear: "أنت لست أفكارك. راقب خوفك دون حكم، وسوف يفقد قوته.",
    quote_fragile: "حساسيتك هي قوتك. احترم حيث أنت الآن.",
    quote_grateful: "الامتنان يحول ما لدينا إلى كافٍ. — ميلودي بيتي",
    quote_guilt: "الأخطاء دليل على أنك تحاول. تعلم، اغفر لنفسك وامض قدماً.",
    quote_hopeful: "الأمل قوي. يمكن أن يدفعنا للأمام حتى في أحلك الأوقات.",
    quote_powerless: "القوة لا تأتي من تغيير الظروف الخارجية، بل من إدراك القوة الداخلية.",
    quote_courageous_powerful: "الشجاعة ليست غياب الخوف، بل الحكم بأن شيئاً آخر أكثر أهمية.",
    quote_stressed_tense: "التنفس مثل جهاز التحكم عن بعد لجهازك العصبي. — الدكتور أندرو ويل",
    quote_tender: "هناك قوة هائلة في الحنان. دع حساسيتك تكون أعظم قوتك.",
    quote_unsettled_doubt: "في خضم الشك، توقف وعد إلى أنفاسك. الوضوح سيأتي مع الوقت.",
    
    // Settings
    select_language_desc: "اختر لغتك المفضلة",
    language_updated: "تم تحديث اللغة!",
    profile_information: "معلومات الملف الشخصي",
    saving: "جاري الحفظ"
  },
  
  fr: {
    // French translations - Complete
    landing_title: "Comprendre Votre Paysage Émotionnel",
    landing_subtitle: "Un outil professionnel pour suivre les schémas émotionnels, obtenir des insights et cultiver l'intelligence émotionnelle.",
    welcome_back: "Bon Retour",
    begin_journey: "Commencez Votre Voyage",
    name: "Nom",
    first_name: "Prénom",
    surname: "Nom de famille",
    email: "Email",
    password: "Mot de passe",
    log_in: "Se Connecter",
    create_account: "Créer un Compte",
    
    // Navigation
    dashboard: "Tableau de bord",
    history: "Historique",
    journal: "Journal",
    music: "Musique",
    community: "Communauté",
    chat: "Discussion",
    voice: "Voix",
    settings: "Paramètres",
    logout: "Déconnexion",
    back: "Retour",
    home: "Accueil",
    welcome: "Bienvenue",
    
    // Dashboard
    good_to_see: "Ravi de vous voir",
    lets_explore: "Explorons ce que vous ressentez maintenant",
    step_of: "Étape {step} sur {total}",
    whats_primary_feeling: "Quel est votre sentiment principal maintenant?",
    browse_emotions: "Parcourir les émotions avec le carrousel",
    which_specific_feeling: "Quel sentiment spécifique résonne le plus?",
    what_physical_sensations: "Quelles sensations physiques accompagnent ce sentiment?",
    when_you_feel: "Quand vous ressentez",
    what_notice_body: "que remarquez-vous dans votre corps?",
    continue_to_context: "Continuer au Contexte",
    no_physical_sensations: "Je ne ressens aucune sensation physique → Passer",
    add_context_intensity: "Ajouter contexte et intensité",
    your_emotional_state: "Votre État Émotionnel",
    category: "Catégorie",
    body: "Corps",
    how_intense: "Quelle est l'intensité de ce sentiment?",
    whats_reason: "Quelle est la raison ou le contexte?",
    save_track_emotion: "Enregistrer et Suivre l'Émotion",
    track_another: "Suivre Une Autre Émotion",
    mild: "Léger",
    strong: "Fort",
    based_on_feeling: "Basé sur votre sentiment:",
    try_these_actions: "Essayez Ces Actions:",
    click_to_try: "Cliquez pour essayer",
    select_this_category: "Sélectionner Cette Catégorie",
    specific_feelings: "{count} sentiments spécifiques",
    positive: "Positif",
    challenging: "Difficile",
    neutral: "Neutre",
    quote_of_moment: "Citation du Moment",
    your_insights: "Vos Perspectives",
    gender: "Genre",
    male: "Homme",
    female: "Femme",
    
    // Emotion Categories
    emotion_accepting_open: "Acceptant/Ouvert",
    emotion_aliveness_joy: "Vitalité/Joie",
    emotion_angry_annoyed: "En colère/Agacé",
    emotion_connected_loving: "Connecté/Aimant",
    emotion_curious: "Curieux",
    emotion_despair_sad: "Désespoir/Triste",
    emotion_disconnected_numb: "Déconnecté/Engourdi",
    emotion_embarrassed_shame: "Embarrassé/Honte",
    emotion_fear: "Peur",
    emotion_fragile: "Fragile",
    emotion_grateful: "Reconnaissant",
    emotion_guilt: "Culpabilité",
    emotion_hopeful: "Plein d'espoir",
    emotion_powerless: "Impuissant",
    emotion_courageous_powerful: "Courageux/Puissant",
    emotion_stressed_tense: "Stressé/Tendu",
    emotion_tender: "Tendre",
    emotion_unsettled_doubt: "Inquiet/Doute",
    
    // Feelings (170+)
    feeling_calm: "Calme",
    feeling_happy: "Heureux",
    feeling_excited: "Excité",
    feeling_anxious: "Anxieux",
    feeling_sad: "Triste",
    feeling_angry: "En colère",
    feeling_peaceful: "Paisible",
    feeling_grateful: "Reconnaissant",
    feeling_worried: "Inquiet",
    feeling_confident: "Confiant",
    feeling_frustrated: "Frustré",
    feeling_content: "Content",
    feeling_scared: "Effrayé",
    feeling_hopeful: "Plein d'espoir",
    feeling_lonely: "Seul",
    feeling_energized: "Énergisé",
    feeling_tired: "Fatigué",
    feeling_relaxed: "Détendu",
    feeling_helpless: "Désemparé",
    feeling_sensitive: "Sensible",
    feeling_centered: "Centré",
    feeling_fulfilled: "Accompli",
    feeling_patient: "Patient",
    feeling_present: "Présent",
    feeling_serene: "Serein",
    feeling_trusting: "Confiant",
    feeling_amazed: "Émerveillé",
    feeling_awe: "Émerveillement",
    feeling_bliss: "Béatitude",
    feeling_delighted: "Ravi",
    feeling_eager: "Impatient",
    feeling_ecstatic: "Extatique",
    feeling_enchanted: "Enchanté",
    feeling_engaged: "Engagé",
    feeling_enthusiastic: "Enthousiaste",
    feeling_free: "Libre",
    feeling_inspired: "Inspiré",
    feeling_invigorated: "Revigoré",
    feeling_lively: "Vivant",
    feeling_passionate: "Passionné",
    feeling_playful: "Joueur",
    feeling_radiant: "Radieux",
    feeling_refreshed: "Rafraîchi",
    feeling_rejuvenated: "Rajeuni",
    feeling_renewed: "Renouvelé",
    feeling_satisfied: "Satisfait",
    feeling_thrilled: "Ravi",
    feeling_vibrant: "Vibrant",
    feeling_agitated: "Agité",
    feeling_aggravated: "Aggravé",
    feeling_bitter: "Amer",
    feeling_contempt: "Mépris",
    feeling_cynical: "Cynique",
    feeling_disdain: "Dédain",
    feeling_disgruntled: "Mécontent",
    feeling_disturbed: "Perturbé",
    feeling_edgy: "Nerveux",
    feeling_exasperated: "Exaspéré",
    feeling_furious: "Furieux",
    feeling_grouchy: "Grincheux",
    feeling_hostile: "Hostile",
    feeling_impatient: "Impatient",
    feeling_irritated: "Irrité",
    feeling_irate: "Furieux",
    feeling_moody: "Lunatique",
    feeling_on_edge: "À bout",
    feeling_outraged: "Indigné",
    feeling_pissed: "Énervé",
    feeling_resentful: "Rancunier",
    feeling_upset: "Bouleversé",
    feeling_vindictive: "Vindicatif",
    feeling_accepting: "Acceptant",
    feeling_affectionate: "Affectueux",
    feeling_caring: "Attentionné",
    feeling_compassion: "Compassion",
    feeling_empathy: "Empathie",
    feeling_safe: "En sécurité",
    feeling_warm: "Chaleureux",
    feeling_worthy: "Digne",
    feeling_exploring: "Explorant",
    feeling_fascinated: "Fasciné",
    feeling_interested: "Intéressé",
    feeling_intrigued: "Intrigué",
    feeling_involved: "Impliqué",
    feeling_stimulated: "Stimulé",
    feeling_anguish: "Angoisse",
    feeling_depressed: "Déprimé",
    feeling_despondent: "Découragé",
    feeling_disappointed: "Déçu",
    feeling_discouraged: "Découragé",
    feeling_forlorn: "Désolé",
    feeling_gloomy: "Sombre",
    feeling_grief: "Deuil",
    feeling_heartbroken: "Le cœur brisé",
    feeling_hopeless: "Désespéré",
    feeling_longing: "Nostalgie",
    feeling_melancholy: "Mélancolie",
    feeling_sorrow: "Chagrin",
    feeling_teary: "Larmoyant",
    feeling_unhappy: "Malheureux",
    feeling_weary: "Épuisé",
    feeling_yearning: "Aspirant",
    feeling_aloof: "Distant",
    feeling_bored: "Ennuyé",
    feeling_confused: "Confus",
    feeling_distant: "Distant",
    feeling_empty: "Vide",
    feeling_indifferent: "Indifférent",
    feeling_isolated: "Isolé",
    feeling_lethargic: "Léthargique",
    feeling_listless: "Apathique",
    feeling_removed: "Éloigné",
    feeling_resistant: "Résistant",
    feeling_shut_down: "Fermé",
    feeling_uneasy: "Mal à l'aise",
    feeling_withdrawn: "Renfermé",
    feeling_ashamed: "Honteux",
    feeling_humiliated: "Humilié",
    feeling_inhibited: "Inhibé",
    feeling_mortified: "Mortifié",
    feeling_self_conscious: "Gêné",
    feeling_useless: "Inutile",
    feeling_weak: "Faible",
    feeling_worthless: "Sans valeur",
    feeling_afraid: "Effrayé",
    feeling_apprehensive: "Appréhensif",
    feeling_frightened: "Apeuré",
    feeling_hesitant: "Hésitant",
    feeling_nervous: "Nerveux",
    feeling_panic: "Panique",
    feeling_paralyzed: "Paralysé",
    feeling_terrified: "Terrifié",
    feeling_appreciative: "Reconnaissant",
    feeling_blessed: "Béni",
    feeling_fortunate: "Chanceux",
    feeling_grace: "Grâce",
    feeling_humbled: "Humble",
    feeling_lucky: "Chanceux",
    feeling_moved: "Ému",
    feeling_thankful: "Reconnaissant",
    feeling_touched: "Touché",
    feeling_regret: "Regret",
    feeling_remorseful: "Repentant",
    feeling_sorry: "Désolé",
    feeling_encouraged: "Encouragé",
    feeling_expectant: "Confiant",
    feeling_optimistic: "Optimiste",
    feeling_impotent: "Impuissant",
    feeling_incapable: "Incapable",
    feeling_resigned: "Résigné",
    feeling_trapped: "Piégé",
    feeling_victim: "Victime",
    feeling_adventurous: "Aventureux",
    feeling_brave: "Courageux",
    feeling_capable: "Capable",
    feeling_daring: "Audacieux",
    feeling_determined: "Déterminé",
    feeling_grounded: "Ancré",
    feeling_proud: "Fier",
    feeling_strong: "Fort",
    feeling_valiant: "Vaillant",
    feeling_burned_out: "Épuisé",
    feeling_cranky: "Irritable",
    feeling_depleted: "Épuisé",
    feeling_exhausted: "Exténué",
    feeling_frazzled: "Stressé",
    feeling_overwhelm: "Submergé",
    feeling_rattled: "Ébranlé",
    feeling_rejecting: "Rejetant",
    feeling_restless: "Agité",
    feeling_shaken: "Secoué",
    feeling_tight: "Tendu",
    feeling_worn_out: "Usé",
    feeling_loving: "Aimant",
    feeling_reflective: "Réfléchi",
    feeling_self_loving: "Amour de soi",
    feeling_vulnerable: "Vulnérable",
    feeling_concerned: "Préoccupé",
    feeling_dissatisfied: "Insatisfait",
    feeling_perplexed: "Perplexe",
    feeling_questioning: "Questionnant",
    feeling_reluctant: "Réticent",
    feeling_shocked: "Choqué",
    feeling_skeptical: "Sceptique",
    feeling_suspicious: "Méfiant",
    feeling_ungrounded: "Déstabilisé",
    feeling_unsure: "Incertain",
    
    // Quotes in French
    quote_accepting_open: "Si votre compassion ne vous inclut pas, elle est incomplète. — Jack Kornfield",
    quote_aliveness_joy: "La joie est ce qui se produit lorsque nous nous permettons de reconnaître à quel point les choses sont bonnes. — Marianne Williamson",
    quote_angry_annoyed: "La colère est un acide qui peut faire plus de mal au récipient qui la contient. — Mark Twain",
    quote_connected_loving: "Où il y a de l'amour, il y a de la vie. — Mahatma Gandhi",
    quote_curious: "Connais-toi toi-même, car une fois que nous nous connaissons, nous pouvons apprendre à prendre soin de nous. — Socrate",
    quote_despair_sad: "Cela aussi passera. Chaque émotion est temporaire, et la guérison est un voyage.",
    quote_disconnected_numb: "Tant que vous ne vous valorisez pas, vous ne valoriserez pas votre temps. — Swami Vivekananda",
    quote_embarrassed_shame: "La guérison vient de la prise de responsabilité et de la compassion envers soi-même.",
    quote_fear: "Vous n'êtes pas vos pensées. Observez votre peur sans jugement, et elle perdra son pouvoir.",
    quote_fragile: "Votre sensibilité est votre force. Honorez où vous êtes maintenant.",
    quote_grateful: "La gratitude transforme ce que nous avons en suffisant. — Melody Beattie",
    quote_guilt: "Les erreurs sont la preuve que vous essayez. Apprenez, pardonnez-vous et avancez.",
    quote_hopeful: "L'espoir est puissant. Il peut nous faire avancer même dans les moments les plus sombres.",
    quote_powerless: "Le pouvoir ne vient pas du changement des circonstances extérieures, mais de la reconnaissance de la force intérieure.",
    quote_courageous_powerful: "Le courage n'est pas l'absence de peur, mais le jugement qu'autre chose est plus important.",
    quote_stressed_tense: "La respiration est comme une télécommande pour votre système nerveux. — Dr. Andrew Weil",
    quote_tender: "Il y a un immense pouvoir dans la tendresse. Laissez votre sensibilité être votre plus grande force.",
    quote_unsettled_doubt: "Au milieu du doute, faites une pause et revenez à votre respiration. La clarté viendra avec le temps.",
    
    // Settings
    select_language_desc: "Choisissez votre langue préférée",
    language_updated: "Langue mise à jour!",
    profile_information: "Informations du Profil",
    saving: "Enregistrement"
  },
  
  de: {
    // German translations - Complete
    landing_title: "Verstehen Sie Ihre Emotionale Landschaft",
    landing_subtitle: "Ein professionelles Werkzeug zur Verfolgung emotionaler Muster, Gewinnung von Erkenntnissen und Kultivierung emotionaler Intelligenz.",
    welcome_back: "Willkommen Zurück",
    begin_journey: "Beginnen Sie Ihre Reise",
    name: "Name",
    first_name: "Vorname",
    surname: "Nachname",
    email: "E-Mail",
    password: "Passwort",
    log_in: "Anmelden",
    create_account: "Konto Erstellen",
    
    // Navigation
    dashboard: "Dashboard",
    history: "Verlauf",
    journal: "Tagebuch",
    music: "Musik",
    community: "Gemeinschaft",
    chat: "Chat",
    voice: "Stimme",
    settings: "Einstellungen",
    logout: "Abmelden",
    back: "Zurück",
    home: "Startseite",
    welcome: "Willkommen",
    
    // Dashboard
    good_to_see: "Schön, Sie zu sehen",
    lets_explore: "Lassen Sie uns erkunden, wie Sie sich jetzt fühlen",
    step_of: "Schritt {step} von {total}",
    whats_primary_feeling: "Was ist Ihr primäres Gefühl jetzt?",
    browse_emotions: "Emotionen durchstöbern mit dem Karussell",
    which_specific_feeling: "Welches spezifische Gefühl resoniert am meisten?",
    what_physical_sensations: "Welche körperlichen Empfindungen begleiten dieses Gefühl?",
    when_you_feel: "Wenn Sie fühlen",
    what_notice_body: "was bemerken Sie in Ihrem Körper?",
    continue_to_context: "Weiter zum Kontext",
    no_physical_sensations: "Ich fühle keine körperlichen Empfindungen → Überspringen",
    add_context_intensity: "Kontext und Intensität hinzufügen",
    your_emotional_state: "Ihr Emotionaler Zustand",
    category: "Kategorie",
    body: "Körper",
    how_intense: "Wie intensiv ist dieses Gefühl?",
    whats_reason: "Was ist der Grund oder Kontext?",
    save_track_emotion: "Speichern und Emotion Verfolgen",
    track_another: "Eine Andere Emotion Verfolgen",
    mild: "Mild",
    strong: "Stark",
    based_on_feeling: "Basierend auf Ihrem Gefühl:",
    try_these_actions: "Probieren Sie Diese Aktionen:",
    click_to_try: "Klicken zum Ausprobieren",
    select_this_category: "Diese Kategorie Auswählen",
    specific_feelings: "{count} spezifische Gefühle",
    positive: "Positiv",
    challenging: "Herausfordernd",
    neutral: "Neutral",
    quote_of_moment: "Zitat des Moments",
    your_insights: "Ihre Einsichten",
    gender: "Geschlecht",
    male: "Mann",
    female: "Frau",
    
    // Emotion Categories
    emotion_accepting_open: "Akzeptierend/Offen",
    emotion_aliveness_joy: "Lebendigkeit/Freude",
    emotion_angry_annoyed: "Wütend/Verärgert",
    emotion_connected_loving: "Verbunden/Liebevoll",
    emotion_curious: "Neugierig",
    emotion_despair_sad: "Verzweiflung/Traurig",
    emotion_disconnected_numb: "Getrennt/Taub",
    emotion_embarrassed_shame: "Verlegen/Scham",
    emotion_fear: "Angst",
    emotion_fragile: "Zerbrechlich",
    emotion_grateful: "Dankbar",
    emotion_guilt: "Schuld",
    emotion_hopeful: "Hoffnungsvoll",
    emotion_powerless: "Machtlos",
    emotion_courageous_powerful: "Mutig/Mächtig",
    emotion_stressed_tense: "Gestresst/Angespannt",
    emotion_tender: "Zart",
    emotion_unsettled_doubt: "Unruhig/Zweifel",
    
    // Feelings (170+)
    feeling_calm: "Ruhig",
    feeling_happy: "Glücklich",
    feeling_excited: "Aufgeregt",
    feeling_anxious: "Ängstlich",
    feeling_sad: "Traurig",
    feeling_angry: "Wütend",
    feeling_peaceful: "Friedlich",
    feeling_grateful: "Dankbar",
    feeling_worried: "Besorgt",
    feeling_confident: "Selbstbewusst",
    feeling_frustrated: "Frustriert",
    feeling_content: "Zufrieden",
    feeling_scared: "Verängstigt",
    feeling_hopeful: "Hoffnungsvoll",
    feeling_lonely: "Einsam",
    feeling_energized: "Energiegeladen",
    feeling_tired: "Müde",
    feeling_relaxed: "Entspannt",
    feeling_helpless: "Hilflos",
    feeling_sensitive: "Sensibel",
    feeling_centered: "Zentriert",
    feeling_fulfilled: "Erfüllt",
    feeling_patient: "Geduldig",
    feeling_present: "Präsent",
    feeling_serene: "Gelassen",
    feeling_trusting: "Vertrauend",
    feeling_amazed: "Erstaunt",
    feeling_awe: "Ehrfurcht",
    feeling_bliss: "Glückseligkeit",
    feeling_delighted: "Erfreut",
    feeling_eager: "Eifrig",
    feeling_ecstatic: "Ekstatisch",
    feeling_enchanted: "Verzaubert",
    feeling_engaged: "Engagiert",
    feeling_enthusiastic: "Begeistert",
    feeling_free: "Frei",
    feeling_inspired: "Inspiriert",
    feeling_invigorated: "Belebt",
    feeling_lively: "Lebhaft",
    feeling_passionate: "Leidenschaftlich",
    feeling_playful: "Verspielt",
    feeling_radiant: "Strahlend",
    feeling_refreshed: "Erfrischt",
    feeling_rejuvenated: "Verjüngt",
    feeling_renewed: "Erneuert",
    feeling_satisfied: "Zufrieden",
    feeling_thrilled: "Begeistert",
    feeling_vibrant: "Lebendig",
    feeling_agitated: "Aufgebracht",
    feeling_aggravated: "Verschlimmert",
    feeling_bitter: "Verbittert",
    feeling_contempt: "Verachtung",
    feeling_cynical: "Zynisch",
    feeling_disdain: "Geringschätzung",
    feeling_disgruntled: "Verstimmt",
    feeling_disturbed: "Gestört",
    feeling_edgy: "Gereizt",
    feeling_exasperated: "Verzweifelt",
    feeling_furious: "Wütend",
    feeling_grouchy: "Mürrisch",
    feeling_hostile: "Feindselig",
    feeling_impatient: "Ungeduldig",
    feeling_irritated: "Gereizt",
    feeling_irate: "Verärgert",
    feeling_moody: "Launisch",
    feeling_on_edge: "Am Limit",
    feeling_outraged: "Empört",
    feeling_pissed: "Sauer",
    feeling_resentful: "Grollend",
    feeling_upset: "Verärgert",
    feeling_vindictive: "Rachsüchtig",
    feeling_accepting: "Akzeptierend",
    feeling_affectionate: "Liebevoll",
    feeling_caring: "Fürsorglich",
    feeling_compassion: "Mitgefühl",
    feeling_empathy: "Empathie",
    feeling_safe: "Sicher",
    feeling_warm: "Warm",
    feeling_worthy: "Würdig",
    feeling_exploring: "Erkundend",
    feeling_fascinated: "Fasziniert",
    feeling_interested: "Interessiert",
    feeling_intrigued: "Neugierig",
    feeling_involved: "Beteiligt",
    feeling_stimulated: "Stimuliert",
    feeling_anguish: "Qual",
    feeling_depressed: "Deprimiert",
    feeling_despondent: "Mutlos",
    feeling_disappointed: "Enttäuscht",
    feeling_discouraged: "Entmutigt",
    feeling_forlorn: "Verlassen",
    feeling_gloomy: "Düster",
    feeling_grief: "Trauer",
    feeling_heartbroken: "Herzgebrochen",
    feeling_hopeless: "Hoffnungslos",
    feeling_longing: "Sehnsucht",
    feeling_melancholy: "Melancholie",
    feeling_sorrow: "Kummer",
    feeling_teary: "Tränenreich",
    feeling_unhappy: "Unglücklich",
    feeling_weary: "Müde",
    feeling_yearning: "Sehnend",
    feeling_aloof: "Distanziert",
    feeling_bored: "Gelangweilt",
    feeling_confused: "Verwirrt",
    feeling_distant: "Distanziert",
    feeling_empty: "Leer",
    feeling_indifferent: "Gleichgültig",
    feeling_isolated: "Isoliert",
    feeling_lethargic: "Lethargisch",
    feeling_listless: "Lustlos",
    feeling_removed: "Entfernt",
    feeling_resistant: "Widerständig",
    feeling_shut_down: "Verschlossen",
    feeling_uneasy: "Unruhig",
    feeling_withdrawn: "Zurückgezogen",
    feeling_ashamed: "Beschämt",
    feeling_humiliated: "Gedemütigt",
    feeling_inhibited: "Gehemmt",
    feeling_mortified: "Beschämt",
    feeling_self_conscious: "Befangen",
    feeling_useless: "Nutzlos",
    feeling_weak: "Schwach",
    feeling_worthless: "Wertlos",
    feeling_afraid: "Ängstlich",
    feeling_apprehensive: "Besorgt",
    feeling_frightened: "Erschrocken",
    feeling_hesitant: "Zögernd",
    feeling_nervous: "Nervös",
    feeling_panic: "Panik",
    feeling_paralyzed: "Gelähmt",
    feeling_terrified: "Verängstigt",
    feeling_appreciative: "Wertschätzend",
    feeling_blessed: "Gesegnet",
    feeling_fortunate: "Glücklich",
    feeling_grace: "Gnade",
    feeling_humbled: "Demütig",
    feeling_lucky: "Glücklich",
    feeling_moved: "Bewegt",
    feeling_thankful: "Dankbar",
    feeling_touched: "Berührt",
    feeling_regret: "Bedauern",
    feeling_remorseful: "Reumütig",
    feeling_sorry: "Es tut mir leid",
    feeling_encouraged: "Ermutigt",
    feeling_expectant: "Erwartungsvoll",
    feeling_optimistic: "Optimistisch",
    feeling_impotent: "Ohnmächtig",
    feeling_incapable: "Unfähig",
    feeling_resigned: "Resigniert",
    feeling_trapped: "Gefangen",
    feeling_victim: "Opfer",
    feeling_adventurous: "Abenteuerlustig",
    feeling_brave: "Mutig",
    feeling_capable: "Fähig",
    feeling_daring: "Gewagt",
    feeling_determined: "Entschlossen",
    feeling_grounded: "Geerdet",
    feeling_proud: "Stolz",
    feeling_strong: "Stark",
    feeling_valiant: "Tapfer",
    feeling_burned_out: "Ausgebrannt",
    feeling_cranky: "Reizbar",
    feeling_depleted: "Erschöpft",
    feeling_exhausted: "Erschöpft",
    feeling_frazzled: "Gestresst",
    feeling_overwhelm: "Überwältigt",
    feeling_rattled: "Erschüttert",
    feeling_rejecting: "Ablehnend",
    feeling_restless: "Rastlos",
    feeling_shaken: "Erschüttert",
    feeling_tight: "Angespannt",
    feeling_worn_out: "Abgenutzt",
    feeling_loving: "Liebevoll",
    feeling_reflective: "Nachdenklich",
    feeling_self_loving: "Selbstliebend",
    feeling_vulnerable: "Verletzlich",
    feeling_concerned: "Besorgt",
    feeling_dissatisfied: "Unzufrieden",
    feeling_perplexed: "Ratlos",
    feeling_questioning: "Hinterfragend",
    feeling_reluctant: "Widerwillig",
    feeling_shocked: "Schockiert",
    feeling_skeptical: "Skeptisch",
    feeling_suspicious: "Misstrauisch",
    feeling_ungrounded: "Unverankert",
    feeling_unsure: "Unsicher",
    
    // Quotes in German
    quote_accepting_open: "Wenn Ihr Mitgefühl Sie selbst nicht einschließt, ist es unvollständig. — Jack Kornfield",
    quote_aliveness_joy: "Freude ist das, was passiert, wenn wir uns erlauben zu erkennen, wie gut die Dinge wirklich sind. — Marianne Williamson",
    quote_angry_annoyed: "Wut ist eine Säure, die dem Gefäß, in dem sie aufbewahrt wird, mehr schaden kann. — Mark Twain",
    quote_connected_loving: "Wo Liebe ist, ist Leben. — Mahatma Gandhi",
    quote_curious: "Erkenne dich selbst, denn sobald wir uns kennen, können wir lernen, für uns zu sorgen. — Sokrates",
    quote_despair_sad: "Auch dies wird vorübergehen. Jede Emotion ist vorübergehend, und Heilung ist eine Reise.",
    quote_disconnected_numb: "Bis Sie sich selbst schätzen, werden Sie Ihre Zeit nicht schätzen. — Swami Vivekananda",
    quote_embarrassed_shame: "Heilung kommt von Verantwortung und Selbstmitgefühl.",
    quote_fear: "Sie sind nicht Ihre Gedanken. Beobachten Sie Ihre Angst ohne Urteil, und sie wird ihre Macht verlieren.",
    quote_fragile: "Ihre Sensibilität ist Ihre Stärke. Ehren Sie, wo Sie jetzt sind.",
    quote_grateful: "Dankbarkeit verwandelt das, was wir haben, in genug. — Melody Beattie",
    quote_guilt: "Fehler sind der Beweis, dass Sie es versuchen. Lernen Sie, vergeben Sie sich und gehen Sie weiter.",
    quote_hopeful: "Hoffnung ist mächtig. Sie kann uns auch in den dunkelsten Zeiten voranbringen.",
    quote_powerless: "Macht kommt nicht von der Veränderung äußerer Umstände, sondern von der Erkenntnis der inneren Stärke.",
    quote_courageous_powerful: "Mut ist nicht die Abwesenheit von Angst, sondern das Urteil, dass etwas anderes wichtiger ist.",
    quote_stressed_tense: "Der Atem ist wie eine Fernbedienung für Ihr Nervensystem. — Dr. Andrew Weil",
    quote_tender: "In der Zärtlichkeit liegt immense Kraft. Lassen Sie Ihre Sensibilität Ihre größte Stärke sein.",
    quote_unsettled_doubt: "Inmitten des Zweifels halten Sie inne und kehren Sie zu Ihrem Atem zurück. Klarheit wird mit der Zeit kommen.",
    
    // Settings
    select_language_desc: "Wählen Sie Ihre bevorzugte Sprache",
    language_updated: "Sprache aktualisiert!",
    profile_information: "Profilinformationen",
    saving: "Speichern"
  },
  
  hi: {
    // Hindi translations - Complete
    // Landing Page
    landing_title: "अपने भावनात्मक परिदृश्य को समझें",
    landing_subtitle: "भावनात्मक पैटर्न को ट्रैक करने, अंतर्दृष्टि प्राप्त करने और भावनात्मक बुद्धिमत्ता विकसित करने के लिए एक पेशेवर उपकरण।",
    multi_dimensional: "बहुआयामी ट्रैकिंग",
    multi_dimensional_desc: "संयोजन, उत्तेजना और संदर्भ में भावनाओं का मानचित्रण",
    pattern_recognition: "पैटर्न पहचान",
    pattern_recognition_desc: "अपनी भावनात्मक कल्याण यात्रा में रुझान खोजें",
    community_insights: "सामुदायिक अंतर्दृष्टि",
    community_insights_desc: "साझा अनुभवों से जुड़ें, गुमनाम रूप से",
    ai_companion: "एआई साथी",
    ai_companion_desc: "साक्ष्य-आधारित समर्थन और चिंतन",
    welcome_back: "वापसी पर स्वागत है",
    begin_journey: "अपनी यात्रा शुरू करें",
    name: "नाम",
    first_name: "पहला नाम",
    surname: "उपनाम",
    email: "ईमेल",
    password: "पासवर्ड",
    log_in: "लॉग इन करें",
    create_account: "खाता बनाएं",
    no_account: "खाता नहीं है? एक बनाएं",
    have_account: "पहले से खाता है? लॉग इन करें",
    continue_with_google: "गूगल से जारी रखें",
    or: "या",
    
    // Onboarding
    complete_profile: "अपना प्रोफ़ाइल पूरा करें",
    step_of: "चरण {current} का {total}",
    tell_us_about: "अपने बारे में बताएं",
    select_gender: "अपना लिंग चुनें",
    male: "पुरुष",
    female: "महिला",
    verify_email: "अपना ईमेल सत्यापित करें",
    verify_phone: "अपना फ़ोन सत्यापित करें (वैकल्पिक)",
    send_verification_code: "सत्यापन कोड भेजें",
    enter_code: "6-अंकीय कोड दर्ज करें",
    verify: "सत्यापित करें",
    resend_code: "कोड पुनः भेजें",
    skip_verification: "सत्यापन छोड़ें",
    your_location: "आपका स्थान",
    country: "देश",
    city: "शहर",
    area: "क्षेत्र / पड़ोस",
    phone_number: "फ़ोन नंबर",
    language_preference: "पसंदीदा भाषा",
    music_preferences: "संगीत प्राथमिकताएं",
    music_pref_desc: "उन शैलियों का चयन करें जिन्हें आप पसंद करते हैं",
    food_preferences: "आहार प्राथमिकताएं",
    food_pref_desc: "कोई आहार प्रतिबंध या प्राथमिकताएं",
    wellness_goals: "कल्याण लक्ष्य",
    wellness_goals_desc: "आप MyMojo में क्यों आए?",
    continue: "जारी रखें",
    skip: "अभी छोड़ें",
    complete_setup: "सेटअप पूरा करें",
    
    // Dashboard
    good_to_see: "आपको देखकर अच्छा लगा",
    lets_explore: "आइए जानें कि आप अभी कैसा महसूस कर रहे हैं",
    check_in_prompt: "अपने साथ जांच करने के लिए एक पल लें",
    how_feeling_today: "आज आप कैसा महसूस कर रहे हैं?",
    step_of: "चरण {step} का {total}",
    whats_primary_feeling: "आप अभी मुख्य रूप से क्या महसूस कर रहे हैं?",
    browse_emotions: "करूसेल का उपयोग करके भावनाओं को ब्राउज़ करें",
    which_specific_feeling: "कौन सी विशिष्ट भावना सबसे अधिक प्रतिध्वनित होती है?",
    select_one_below: "नीचे से एक चुनें",
    what_physical_sensations: "इस भावना के साथ कौन सी शारीरिक संवेदनाएं हैं?",
    when_you_feel: "जब आप महसूस करते हैं",
    what_notice_body: "आप अपने शरीर में क्या नोटिस करते हैं?",
    for_example_sensations: "उदाहरण के लिए: हाथों में झुनझुनी, गर्म छाती, ऊर्जावान पैर, तनावग्रस्त कंधे, पेट में तितलियाँ",
    continue_to_context: "संदर्भ के लिए जारी रखें",
    no_physical_sensations: "मुझे अभी कोई शारीरिक संवेदना महसूस नहीं हो रही है → छोड़ें",
    add_context_intensity: "संदर्भ और तीव्रता जोड़ें",
    your_emotional_state: "आपकी भावनात्मक स्थिति",
    category: "श्रेणी",
    body: "शरीर",
    how_intense: "यह भावना कितनी तीव्र है?",
    whats_reason: "कारण या संदर्भ क्या है?",
    why_feeling_this: "आप ऐसा क्यों महसूस कर रहे हैं? क्या हुआ?",
    add_tags: "टैग जोड़ें (वैकल्पिक, अल्पविराम से अलग)",
    example_tags: "उदाहरण: काम, परिवार, स्वास्थ्य",
    save_track_emotion: "सहेजें और भावना ट्रैक करें",
    track_another: "एक और भावना ट्रैक करें",
    quote_of_moment: "इस पल का उद्धरण",
    your_insights: "आपकी अंतर्दृष्टि",
    achievements: "उपलब्धियां",
    unlocked: "अनलॉक किया गया",
    mild: "हल्का",
    strong: "मजबूत",
    based_on_feeling: "आपकी भावना के आधार पर:",
    click_action_below: "👇 शुरू करने के लिए नीचे किसी भी कार्य पर क्लिक करें",
    try_these_actions: "इन कार्यों को आज़माएं:",
    click_to_try: "आज़माने के लिए क्लिक करें",
    open: "खोलें",
    select_this_category: "इस श्रेणी का चयन करें",
    specific_feelings: "{count} विशिष्ट भावनाएं",
    positive: "सकारात्मक",
    challenging: "चुनौतीपूर्ण",
    neutral: "तटस्थ",
    
    // Emotion Categories (Hindi)
    emotion_accepting_open: "स्वीकृत/खुला",
    emotion_aliveness_joy: "जीवंतता/खुशी",
    emotion_angry_annoyed: "क्रोधित/चिढ़ा हुआ",
    emotion_connected_loving: "जुड़ा हुआ/प्यार करने वाला",
    emotion_curious: "जिज्ञासु",
    emotion_despair_sad: "निराशा/उदास",
    emotion_disconnected_numb: "असंबद्ध/सुन्न",
    emotion_embarrassed_shame: "शर्मिंदा/शर्म",
    emotion_fear: "डर",
    emotion_fragile: "नाजुक",
    emotion_grateful: "आभारी",
    emotion_guilt: "अपराधबोध",
    emotion_hopeful: "आशावान",
    emotion_powerless: "शक्तिहीन",
    emotion_courageous_powerful: "साहसी/शक्तिशाली",
    emotion_stressed_tense: "तनावग्रस्त/तनाव",
    emotion_tender: "कोमल",
    emotion_unsettled_doubt: "अस्थिर/संदेह",
    
    // Common Feelings (Hindi)
    feeling_calm: "शांत",
    feeling_happy: "खुश",
    feeling_excited: "उत्साहित",
    feeling_anxious: "चिंतित",
    feeling_sad: "उदास",
    feeling_angry: "गुस्सा",
    feeling_peaceful: "शांतिपूर्ण",
    feeling_grateful: "आभारी",
    feeling_worried: "चिंतित",
    feeling_confident: "आत्मविश्वासी",
    feeling_frustrated: "निराश",
    feeling_content: "संतुष्ट",
    feeling_scared: "डरा हुआ",
    feeling_hopeful: "आशावान",
    feeling_lonely: "अकेला",
    feeling_energized: "ऊर्जावान",
    feeling_tired: "थका हुआ",
    feeling_relaxed: "आराम से",
    feeling_helpless: "असहाय",
    feeling_sensitive: "संवेदनशील",
    feeling_centered: "केंद्रित",
    feeling_fulfilled: "संतुष्ट",
    feeling_patient: "धैर्यवान",
    feeling_present: "उपस्थित",
    feeling_serene: "प्रशांत",
    feeling_trusting: "विश्वासी",
    feeling_amazed: "चकित",
    feeling_awe: "विस्मय",
    feeling_bliss: "परमानंद",
    feeling_delighted: "प्रसन्न",
    feeling_eager: "उत्सुक",
    feeling_ecstatic: "उल्लसित",
    feeling_enchanted: "मोहित",
    feeling_engaged: "व्यस्त",
    feeling_enthusiastic: "उत्साही",
    feeling_free: "स्वतंत्र",
    feeling_inspired: "प्रेरित",
    feeling_invigorated: "ऊर्जावान",
    feeling_lively: "जीवंत",
    feeling_passionate: "भावुक",
    feeling_playful: "खिलाड़ी",
    feeling_radiant: "दीप्तिमान",
    feeling_refreshed: "तरोताजा",
    feeling_rejuvenated: "पुनर्जीवित",
    feeling_renewed: "नवीनीकृत",
    feeling_satisfied: "संतुष्ट",
    feeling_thrilled: "रोमांचित",
    feeling_vibrant: "जीवंत",
    feeling_agitated: "उत्तेजित",
    feeling_aggravated: "बढ़ा हुआ",
    feeling_bitter: "कड़वा",
    feeling_contempt: "तिरस्कार",
    feeling_cynical: "निंदक",
    feeling_disdain: "घृणा",
    feeling_disgruntled: "असंतुष्ट",
    feeling_disturbed: "परेशान",
    feeling_edgy: "चिड़चिड़ा",
    feeling_exasperated: "क्रोधित",
    feeling_furious: "उग्र",
    feeling_grouchy: "चिड़चिड़ा",
    feeling_hostile: "शत्रुतापूर्ण",
    feeling_impatient: "अधीर",
    feeling_irritated: "चिढ़ा हुआ",
    feeling_irate: "क्रोधित",
    feeling_moody: "मूडी",
    feeling_on_edge: "किनारे पर",
    feeling_outraged: "आक्रोशित",
    feeling_pissed: "नाराज",
    feeling_resentful: "क्रोधी",
    feeling_upset: "परेशान",
    feeling_vindictive: "प्रतिशोधी",
    feeling_accepting: "स्वीकार करने वाला",
    feeling_affectionate: "स्नेही",
    feeling_caring: "देखभाल करने वाला",
    feeling_compassion: "करुणा",
    feeling_empathy: "सहानुभूति",
    feeling_safe: "सुरक्षित",
    feeling_warm: "गर्म",
    feeling_worthy: "योग्य",
    feeling_exploring: "अन्वेषण",
    feeling_fascinated: "मोहित",
    feeling_interested: "रुचि",
    feeling_intrigued: "उत्सुक",
    feeling_involved: "शामिल",
    feeling_stimulated: "उत्तेजित",
    feeling_anguish: "पीड़ा",
    feeling_depressed: "उदास",
    feeling_despondent: "निराश",
    feeling_disappointed: "निराश",
    feeling_discouraged: "हतोत्साहित",
    feeling_forlorn: "परित्यक्त",
    feeling_gloomy: "उदास",
    feeling_grief: "शोक",
    feeling_heartbroken: "दिल टूटा हुआ",
    feeling_hopeless: "निराश",
    feeling_longing: "लालसा",
    feeling_melancholy: "उदासी",
    feeling_sorrow: "दुख",
    feeling_teary: "आंसू भरा",
    feeling_unhappy: "नाखुश",
    feeling_weary: "थका हुआ",
    feeling_yearning: "तरसना",
    feeling_aloof: "अलग",
    feeling_bored: "ऊबा हुआ",
    feeling_confused: "भ्रमित",
    feeling_distant: "दूर",
    feeling_empty: "खाली",
    feeling_indifferent: "उदासीन",
    feeling_isolated: "अलग-थलग",
    feeling_lethargic: "सुस्त",
    feeling_listless: "निष्क्रिय",
    feeling_removed: "हटाया गया",
    feeling_resistant: "प्रतिरोधी",
    feeling_shut_down: "बंद",
    feeling_uneasy: "बेचैन",
    feeling_withdrawn: "पीछे हटा हुआ",
    feeling_ashamed: "शर्मिंदा",
    feeling_humiliated: "अपमानित",
    feeling_inhibited: "बाधित",
    feeling_mortified: "शर्मसार",
    feeling_self_conscious: "आत्म-सचेत",
    feeling_useless: "बेकार",
    feeling_weak: "कमजोर",
    feeling_worthless: "निरर्थक",
    feeling_afraid: "डरा हुआ",
    feeling_apprehensive: "आशंकित",
    feeling_frightened: "भयभीत",
    feeling_hesitant: "हिचकिचाहट",
    feeling_nervous: "घबराया हुआ",
    feeling_panic: "घबराहट",
    feeling_paralyzed: "पक्षाघात",
    feeling_terrified: "भयभीत",
    feeling_appreciative: "सराहनीय",
    feeling_blessed: "धन्य",
    feeling_fortunate: "भाग्यशाली",
    feeling_grace: "कृपा",
    feeling_humbled: "विनम्र",
    feeling_lucky: "भाग्यशाली",
    feeling_moved: "द्रवित",
    feeling_thankful: "आभारी",
    feeling_touched: "छुआ हुआ",
    feeling_regret: "पछतावा",
    feeling_remorseful: "पश्चाताप",
    feeling_sorry: "माफ़",
    feeling_encouraged: "प्रोत्साहित",
    feeling_expectant: "आशान्वित",
    feeling_optimistic: "आशावादी",
    feeling_impotent: "शक्तिहीन",
    feeling_incapable: "अक्षम",
    feeling_resigned: "त्यागा हुआ",
    feeling_trapped: "फंसा हुआ",
    feeling_victim: "पीड़ित",
    feeling_adventurous: "साहसी",
    feeling_brave: "बहादुर",
    feeling_capable: "सक्षम",
    feeling_daring: "साहसी",
    feeling_determined: "दृढ़निश्चयी",
    feeling_grounded: "स्थिर",
    feeling_proud: "गर्वित",
    feeling_strong: "मजबूत",
    feeling_valiant: "वीर",
    feeling_burned_out: "थका हुआ",
    feeling_cranky: "चिड़चिड़ा",
    feeling_depleted: "रिक्त",
    feeling_exhausted: "थक गया",
    feeling_frazzled: "परेशान",
    feeling_overwhelm: "अभिभूत",
    feeling_rattled: "हिला हुआ",
    feeling_rejecting: "अस्वीकार",
    feeling_restless: "बेचैन",
    feeling_shaken: "हिला हुआ",
    feeling_tight: "तंग",
    feeling_worn_out: "थक गया",
    feeling_loving: "प्यार करने वाला",
    feeling_reflective: "चिंतनशील",
    feeling_self_loving: "आत्म-प्रेम",
    feeling_vulnerable: "कमजोर",
    feeling_concerned: "चिंतित",
    feeling_dissatisfied: "असंतुष्ट",
    feeling_perplexed: "हैरान",
    feeling_questioning: "सवाल उठाना",
    feeling_reluctant: "अनिच्छुक",
    feeling_shocked: "चौंका",
    feeling_skeptical: "संशयी",
    feeling_suspicious: "संदेहास्पद",
    feeling_ungrounded: "अस्थिर",
    feeling_unsure: "अनिश्चित",
    
    // Quotes in Hindi (with Indian authors where possible)
    quote_accepting_open: "यदि आपकी करुणा में आप स्वयं शामिल नहीं हैं, तो यह अधूरी है। — जैक कॉर्नफील्ड",
    quote_aliveness_joy: "खुशी आपके अंदर से आती है, बाहर से नहीं। — ओशो",
    quote_angry_annoyed: "क्रोध एक अम्ल है जो उस बर्तन को अधिक नुकसान पहुंचाता है जिसमें इसे संग्रहीत किया जाता है। — बुद्ध",
    quote_connected_loving: "जहां प्रेम है, वहां जीवन है। — महात्मा गांधी",
    quote_curious: "स्वयं को जानो, क्योंकि एक बार जब हम खुद को जान लेते हैं, तो हम सीख सकते हैं कि अपनी देखभाल कैसे करें। — सुकरात",
    quote_despair_sad: "यह भी बीत जाएगा। हर भावना अस्थायी है, और उपचार एक यात्रा है।",
    quote_disconnected_numb: "जब तक आप खुद को महत्व नहीं देते, तब तक आप अपने समय को महत्व नहीं देंगे। — स्वामी विवेकानंद",
    quote_embarrassed_shame: "जिम्मेदारी लेने और खुद को करुणा दिखाने से उपचार आता है।",
    quote_fear: "आप अपने विचार नहीं हैं। बिना निर्णय के अपने डर का निरीक्षण करें, और यह अपनी शक्ति खो देगा।",
    quote_fragile: "आपकी संवेदनशीलता आपकी ताकत है। सम्मान करें जहां आप अभी हैं।",
    quote_grateful: "आभार जो हमारे पास है उसे पर्याप्त में बदल देता है। — मेलोडी बीट्टी",
    quote_guilt: "गलतियां सबूत हैं कि आप प्रयास कर रहे हैं। सीखें, खुद को माफ करें, और आगे बढ़ें।",
    quote_hopeful: "आशा शक्तिशाली है। यह सबसे अंधेरे समय में भी हमें आगे बढ़ा सकती है।",
    quote_powerless: "शक्ति बाहरी परिस्थितियों को बदलने से नहीं, बल्कि अपने भीतर की शक्ति को पहचानने से आती है।",
    quote_courageous_powerful: "साहस भय की अनुपस्थिति नहीं है, बल्कि यह निर्णय है कि कुछ और अधिक महत्वपूर्ण है। — अम्बेडकर",
    quote_stressed_tense: "श्वास आपके तंत्रिका तंत्र के लिए रिमोट कंट्रोल की तरह है। — डॉ. एंड्रयू वेल",
    quote_tender: "कोमलता में अपार शक्ति है। अपनी संवेदनशीलता को अपनी श्रेष्ठ शक्ति बनने दें।",
    quote_unsettled_doubt: "संदेह के बीच में, रुकें और अपनी सांस पर लौटें। स्पष्टता समय के साथ आएगी।",
    
    // Navigation
    dashboard: "डैशबोर्ड",
    history: "इतिहास",
    journal: "जर्नल",
    music: "संगीत",
    community: "समुदाय",
    chat: "चैट",
    voice: "आवाज़",
    settings: "सेटिंग्स",
    logout: "लॉग आउट",
    back: "वापस",
    home: "होम",
    welcome: "स्वागत है",
    select_feeling: "एक भावना चुनें",
    body_sensations: "शरीर की संवेदनाएं",
    where_feel: "आप इसे कहां महसूस करते हैं?",
    tap_body: "शरीर के हिस्से पर टैप करें",
    add_context: "संदर्भ जोड़ें",
    whats_happening: "क्या हो रहा है?",
    recommendations: "सिफारिशें",
    quote_of_moment: "पल का उद्धरण",
    share_mood: "अपनी मनोदशा साझा करें",
    emotion_spectrum: "भावना स्पेक्ट्रम",
    selected_emotion: "चयनित भावना",
    intensity_label: "तीव्रता (1 = सबसे कम, 10 = सबसे मजबूत)",
    valence_label: "संयोजन (सुखद ↔ अप्रिय)",
    arousal_label: "उत्तेजना (शांत ↔ ऊर्जावान)",
    context_reflection: "संदर्भ और चिंतन",
    context_placeholder: "इस भावनात्मक स्थिति में क्या योगदान दे रहा है?",
    tags: "टैग",
    tags_placeholder: "काम, रिश्ते, स्वास्थ्य, व्यायाम",
    record_state: "भावनात्मक स्थिति रिकॉर्ड करें",
    your_insights: "आपकी अंतर्दृष्टि",
    total_checkins: "कुल चेक-इन",
    avg_intensity: "औसत तीव्रता",
    recent_states: "हाल की स्थितियां",
    achievements: "उपलब्धियां",
    unlocked: "अनलॉक",
    
    // Navigation
    dashboard: "डैशबोर्ड",
    history: "इतिहास",
    journal: "जर्नल",
    music: "संगीत",
    community: "समुदाय",
    chat: "चैट",
    logout: "लॉग आउट",
    
    // Music & Food
    music_food: "संगीत और कल्याण",
    personalized_recommendations: "आपके मूड के आधार पर वैयक्तिकृत सिफारिशें",
    how_feeling: "आप कैसा महसूस कर रहे हैं?",
    music_for_mood: "आपके मूड के लिए संगीत",
    nearby_wellness: "आस-पास का कल्याण",
    open_spotify: "स्पॉटिफाई में खोलें",
    open_youtube: "यूट्यूब में खोलें",
    open_apple: "एप्पल म्यूज़िक में खोलें",
    filter_language: "भाषा फ़िल्टर",
    filter_era: "युग फ़िल्टर",
    filter_mood: "मूड फ़िल्टर",
    
    // Emotions - Categories
    accepting_open: "स्वीकार/खुला",
    aliveness_joy: "जीवंतता/आनंद",
    angry_annoyed: "गुस्सा/नाराज़",
    connected_loving: "जुड़ा हुआ/प्यार",
    curious: "जिज्ञासु",
    despair_sad: "निराशा/उदास",
    disconnected_numb: "अलग/सुन्न",
    embarrassed_shame: "शर्मिंदा/लज्जा",
    fear: "डर",
    fragile: "नाज़ुक",
    grateful: "कृतज्ञ",
    guilt: "अपराधबोध",
    hopeful: "आशावान",
    powerless: "शक्तिहीन",
    courageous_powerful: "साहसी/शक्तिशाली",
    stressed_tense: "तनावग्रस्त/तनाव",
    tender: "कोमल",
    unsettled_doubt: "अस्थिर/संदेह",
    
    // Basic Emotions
    joy: "आनंद",
    joy_desc: "संतोष और खुशी",
    excitement: "उत्साह",
    excitement_desc: "उच्च ऊर्जा सकारात्मकता",
    serenity: "शांति",
    serenity_desc: "शांतिपूर्ण शांत",
    contentment: "संतुष्टि",
    contentment_desc: "संतुष्ट सुगमता",
    interest: "रुचि",
    interest_desc: "व्यस्त जिज्ञासा",
    neutral: "तटस्थ",
    neutral_desc: "संतुलित स्थिति",
    sadness: "उदासी",
    sadness_desc: "कम मनोदशा",
    anxiety: "चिंता",
    anxiety_desc: "चिंतित तनाव",
    anger: "गुस्सा",
    anger_desc: "निराश झुंझलाहट",
    fatigue: "थकान",
    fatigue_desc: "थकी हुई थकावट",
    melancholy: "विषाद",
    melancholy_desc: "गहरी उदासी",
    overwhelm: "अभिभूत",
    overwhelm_desc: "सामना नहीं कर सकता",
    
    // Body Parts
    head: "सिर",
    throat: "गला",
    shoulders: "कंधे",
    chest: "छाती",
    stomach: "पेट",
    pelvis: "श्रोणि",
    arms: "बाहें",
    legs: "पैर",
    
    // Voice Chat
    voice_chat: "वॉइस चैट",
    start_talking: "बात करना शुरू करें",
    listening: "सुन रहा हूं...",
    processing: "प्रोसेसिंग...",
    tap_to_speak: "बोलने के लिए टैप करें",
    
    // Settings
    settings: "सेटिंग्स",
    back: "वापस",
    select_language_desc: "ऐप के लिए अपनी पसंदीदा भाषा चुनें",
    language_updated: "भाषा सफलतापूर्वक अपडेट की गई!",
    profile_information: "प्रोफ़ाइल जानकारी",
    location: "स्थान",
    saving: "सहेजा जा रहा है",
    gender: "लिंग"
  }
};

export const getTranslation = (language = 'en', key) => {
  // Safety check - always return a string
  if (!key) return '';
  const langTranslations = translations[language] || translations['en'];
  return langTranslations?.[key] || translations['en']?.[key] || key;
};

// Helper function to translate emotion categories
export const translateEmotionCategory = (categoryName, language = 'en') => {
  const key = `emotion_${categoryName.toLowerCase().replace(/\//g, '_').replace(/\s+/g, '_')}`;
  return getTranslation(language, key) || categoryName;
};

// Helper function to translate feelings
export const translateFeeling = (feelingName, language = 'en') => {
  const key = `feeling_${feelingName.toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_')}`;
  return getTranslation(language, key) || feelingName;
};

// Helper function to get translated quote
export const getTranslatedQuote = (categoryName, language = 'en') => {
  const key = `quote_${categoryName.toLowerCase().replace(/\//g, '_').replace(/\s+/g, '_')}`;
  return getTranslation(language, key);
};

export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', rtl: true },
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'de', name: 'German', nativeName: 'Deutsch' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिंदी' }
];

export const MUSIC_GENRES = [
  { value: 'pop', label: 'Pop' },
  { value: 'bollywood', label: 'Bollywood' },
  { value: 'rock', label: 'Rock' },
  { value: 'jazz', label: 'Jazz' },
  { value: 'classical', label: 'Classical' },
  { value: 'ghazal', label: 'Ghazal' },
  { value: 'hip-hop', label: 'Hip-Hop/Rap' },
  { value: 'electronic', label: 'Electronic/EDM' },
  { value: 'indie', label: 'Indie/Alternative' },
  { value: 'r&b', label: 'R&B/Soul' },
  { value: 'country', label: 'Country' },
  { value: 'metal', label: 'Metal' },
  { value: 'blues', label: 'Blues' },
  { value: 'folk', label: 'Folk/Acoustic' }
];

export const DIETARY_PREFERENCES = [
  { value: 'none', label: 'No Restrictions' },
  { value: 'vegetarian', label: 'Vegetarian' },
  { value: 'vegan', label: 'Vegan' },
  { value: 'halal', label: 'Halal' },
  { value: 'kosher', label: 'Kosher' },
  { value: 'gluten-free', label: 'Gluten-Free' },
  { value: 'dairy-free', label: 'Dairy-Free' },
  { value: 'low-carb', label: 'Low-Carb' }
];

export const WELLNESS_GOALS = [
  { value: 'self-awareness', label: 'Build Self-Awareness' },
  { value: 'stress-management', label: 'Manage Stress & Anxiety' },
  { value: 'emotional-regulation', label: 'Improve Emotional Regulation' },
  { value: 'relationships', label: 'Enhance Relationships' },
  { value: 'professional-growth', label: 'Professional Development' },
  { value: 'therapy-support', label: 'Complement Therapy' },
  { value: 'mindfulness', label: 'Practice Mindfulness' },
  { value: 'life-balance', label: 'Achieve Work-Life Balance' }
];


export const FAVORITE_ARTISTS = [
  // Global English Pop/Rock
  { value: 'taylor_swift', label: 'Taylor Swift' },
  { value: 'ed_sheeran', label: 'Ed Sheeran' },
  { value: 'billie_eilish', label: 'Billie Eilish' },
  { value: 'weeknd', label: 'The Weeknd' },
  { value: 'ariana_grande', label: 'Ariana Grande' },
  { value: 'drake', label: 'Drake' },
  { value: 'coldplay', label: 'Coldplay' },
  { value: 'imagine_dragons', label: 'Imagine Dragons' },
  { value: 'bruno_mars', label: 'Bruno Mars' },
  { value: 'adele', label: 'Adele' },
  { value: 'beyonce', label: 'Beyoncé' },
  { value: 'post_malone', label: 'Post Malone' },
  { value: 'dua_lipa', label: 'Dua Lipa' },
  { value: 'justin_bieber', label: 'Justin Bieber' },
  { value: 'rihanna', label: 'Rihanna' },
  { value: 'lady_gaga', label: 'Lady Gaga' },
  { value: 'sam_smith', label: 'Sam Smith' },
  { value: 'shawn_mendes', label: 'Shawn Mendes' },
  { value: 'harry_styles', label: 'Harry Styles' },
  { value: 'olivia_rodrigo', label: 'Olivia Rodrigo' },
  { value: 'kendrick_lamar', label: 'Kendrick Lamar' },
  { value: 'travis_scott', label: 'Travis Scott' },
  { value: 'sza', label: 'SZA' },
  { value: 'frank_ocean', label: 'Frank Ocean' },
  
  // Hindi/Bollywood & Ghazal
  { value: 'arijit_singh', label: 'Arijit Singh' },
  { value: 'ar_rahman', label: 'A.R. Rahman' },
  { value: 'shreya_ghoshal', label: 'Shreya Ghoshal' },
  { value: 'sonu_nigam', label: 'Sonu Nigam' },
  { value: 'neha_kakkar', label: 'Neha Kakkar' },
  { value: 'badshah', label: 'Badshah' },
  { value: 'honey_singh', label: 'Yo Yo Honey Singh' },
  { value: 'guru_randhawa', label: 'Guru Randhawa' },
  { value: 'atif_aslam', label: 'Atif Aslam' },
  { value: 'armaan_malik', label: 'Armaan Malik' },
  { value: 'jagjit_singh', label: 'Jagjit Singh (Ghazal)' },
  { value: 'ghulam_ali', label: 'Ghulam Ali (Ghazal)' },
  { value: 'pankaj_udhas', label: 'Pankaj Udhas (Ghazal)' },
  { value: 'mehdi_hassan', label: 'Mehdi Hassan (Ghazal)' },
  { value: 'farida_khanum', label: 'Farida Khanum (Ghazal)' },
  
  // Spanish/Latin
  { value: 'bad_bunny', label: 'Bad Bunny' },
  { value: 'daddy_yankee', label: 'Daddy Yankee' },
  { value: 'j_balvin', label: 'J Balvin' },
  { value: 'shakira', label: 'Shakira' },
  { value: 'ozuna', label: 'Ozuna' },
  { value: 'maluma', label: 'Maluma' },
  { value: 'karol_g', label: 'Karol G' },
  { value: 'rosalia', label: 'Rosalía' },
  { value: 'marc_anthony', label: 'Marc Anthony' },
  { value: 'enrique_iglesias', label: 'Enrique Iglesias' },
  
  // K-Pop
  { value: 'bts', label: 'BTS' },
  { value: 'blackpink', label: 'BLACKPINK' },
  { value: 'twice', label: 'TWICE' },
  { value: 'stray_kids', label: 'Stray Kids' },
  { value: 'newjeans', label: 'NewJeans' },
  { value: 'seventeen', label: 'SEVENTEEN' },
  
  // French
  { value: 'stromae', label: 'Stromae' },
  { value: 'maitre_gims', label: 'Maître Gims' },
  { value: 'indila', label: 'Indila' },
  { value: 'zaz', label: 'Zaz' },
  { value: 'carla_bruni', label: 'Carla Bruni' },
  
  // German
  { value: 'rammstein', label: 'Rammstein' },
  { value: 'herbert_gronemeyer', label: 'Herbert Grönemeyer' },
  { value: 'sarah_connor', label: 'Sarah Connor' },
  { value: 'mark_forster', label: 'Mark Forster' },
  
  // Arabic
  { value: 'amr_diab', label: 'Amr Diab' },
  { value: 'fairuz', label: 'Fairuz' },
  { value: 'nancy_ajram', label: 'Nancy Ajram' },
  { value: 'tamer_hosny', label: 'Tamer Hosny' },
  { value: 'mohamed_hamaki', label: 'Mohamed Hamaki' },
  
  // Classics/Legends
  { value: 'beatles', label: 'The Beatles' },
  { value: 'queen', label: 'Queen' },
  { value: 'michael_jackson', label: 'Michael Jackson' },
  { value: 'elvis_presley', label: 'Elvis Presley' },
  { value: 'bob_marley', label: 'Bob Marley' },
  
  // Electronic/DJ
  { value: 'calvin_harris', label: 'Calvin Harris' },
  { value: 'martin_garrix', label: 'Martin Garrix' },
  { value: 'david_guetta', label: 'David Guetta' },
  { value: 'marshmello', label: 'Marshmello' }
];


// Genre to Artist mapping for smart filtering
export const GENRE_ARTIST_MAP = {
  'pop': ['taylor_swift', 'ed_sheeran', 'ariana_grande', 'dua_lipa', 'justin_bieber', 'rihanna', 'shawn_mendes', 'harry_styles', 'olivia_rodrigo', 'bruno_mars', 'weeknd'],
  'bollywood': ['arijit_singh', 'ar_rahman', 'shreya_ghoshal', 'sonu_nigam', 'neha_kakkar', 'armaan_malik', 'atif_aslam'],
  'rock': ['coldplay', 'imagine_dragons', 'queen', 'beatles', 'rammstein'],
  'jazz': ['frank_ocean', 'adele'],
  'classical': ['ar_rahman', 'queen', 'beatles'],
  'ghazal': ['jagjit_singh', 'ghulam_ali', 'pankaj_udhas', 'mehdi_hassan', 'farida_khanum'],
  'hip-hop': ['drake', 'kendrick_lamar', 'travis_scott', 'post_malone', 'badshah', 'honey_singh', 'guru_randhawa'],
  'electronic': ['calvin_harris', 'martin_garrix', 'david_guetta', 'marshmello', 'weeknd'],
  'indie': ['billie_eilish', 'sam_smith', 'frank_ocean', 'olivia_rodrigo'],
  'r&b': ['beyonce', 'sza', 'weeknd', 'bruno_mars', 'frank_ocean'],
  'country': ['taylor_swift', 'shawn_mendes'],
  'metal': ['rammstein'],
  'blues': ['adele', 'bob_marley'],
  'folk': ['bob_marley', 'beatles', 'ed_sheeran']
};

// Helper function to get filtered artists based on selected genres
export const getFilteredArtists = (selectedGenres) => {
  if (!selectedGenres || selectedGenres.length === 0) {
    return FAVORITE_ARTISTS; // Show all if no genre selected
  }
  
  // Get unique artist values from selected genres
  const relevantArtistValues = new Set();
  selectedGenres.forEach(genre => {
    const genreArtists = GENRE_ARTIST_MAP[genre] || [];
    genreArtists.forEach(artist => relevantArtistValues.add(artist));
  });
  
  // Filter FAVORITE_ARTISTS to only show relevant ones
  return FAVORITE_ARTISTS.filter(artist => relevantArtistValues.has(artist.value));
};

